export default {
    "accountValidateMsg" : "Tài khoản phải có từ 6-30 ký tự, bao gồm chữ cái, chữ số, “.”、“_”、“@”，ký tự đầu tiên phải là chữ số hoặc chữ cái.",
    "storeSuccess" : "Nạp thành công",
    "editAccountTips" : "Hãy nhập tài khoản có hiệu lực",
    "editPwdTips" : "Hãy nhập mật mã có hiệu lực",
    "editRepeatPwdTips" : "Hãy nhập lại mật mã",
    "pwdRepeatTips" : "Hai lần mật mã khác nhau",
    "changePwdSucc" : "Đổi mật mã thành công",
    "bindEmail" : "Liên kết email",
    "errorVrifyCodeTips" : "Mã xác minh sai",
    "slectQuessionTips" : "Hãy chọn câu hỏi an toàn",
    "answerTips" : "Hãy nhập đáp án",
    "twoAnswerTips" : "Hãy chọn hai câu hỏi an toàn mà bạn đã thiết lập và nhập đáp án của nó",
    "realNameValidateTips" : "Hãy nhập họ tên thật từ 4~60 ký tự",
    "phoneValidateTips" : "Hãy nhập số điện thoại từ 6～18 số",
    "areaSelectTips" : "Hãy chọn khu vực Quốc Gia",
    "iDCardValidataTips" : "Hãy nhập số chứng minh thư từ 1~60 ký tự",
    "changeProfileSucc" : "Sửa thông tin thành công",
    "editVrfCodeTips" : "Hãy nhập mã xác minh",
    "securityQuestionTips" : "Hãy thiết lập câu hỏi an toàn để tăng tính bảo mật cho tài khoản của bạn. Khi bạn quên mật mã, có thể thông qua câu hỏi an toàn để thiết lập lại mật mã một cách nhanh chóng.",
    "validateQuessionTips" : "Chọn hai câu hỏi khác nhau và xác nhận, sau khi hoàn thành xác nhận là có thể reset câu hỏi an toàn.",
    "originPwd" : "Hãy nhập mật mã cũ",
    "newPwd" : "Hãy nhập mật mã mới",
    "changePwdSuccess" : "Đổi mật mã thành công, hãy đăng nhập lại tài khoản đẻ tránh mất dữ liệu",
    "accountName" : "Hãy nhập tên tài khoản",
    "password" : "Mật Mã",
    "repeatPassword" : "Hãy lặp lại mật mã",
    "findPwdTips" : "Hãy nhập tên tài khoản mà bạn muốn tìm lại mật mã",
    "submit" : "Giao",
    "send" : "Gửi",
    "modify" : "Sửa đổi",
    "haveAgree" : "Tôi đã đồng ý",
    "and" : "và",
    "privacyPolicy" : "Chính sách bảo mật",
    "completeness" : "Mức hoàn thiện dữ liệu:",
    "gender" : "Giới tính",
    "male" : "Nam",
    "female" : "Nữ",
    "birthday" : "Sinh nhật",
    "phone" : "Điện thoại liên hệ",
    "region" : "Quốc Gia／Khu vực",
    "ID" : "Số hộ chiếu hoặc chứng minh thư",
    "accountSetting" : "Thiết lập tài khoản",
    "upgrade" : "Nâng cấp tài khoản",
    "profile" : "Dữ liệu cá nhân",
    "changePassword" : "Đổi mật khẩu",
    "securityQuestion" : "Câu hỏi an toàn",
    "creatework_headerTitle" : "Tạo đơn",
    "mylist_headerTitle" : "Đơn của tôi",
    "bindEmailTips" : "Hãy xác thực một email bạn hay dùng để tăng tính bảo mật cho tài khoản của bạn. Khi bạn quên mật khẩu, có thể thông qua email để thiết lập lại mật khẩu.",
    "enterEmailVrfcationTips" : "Hãy nhập mã xác minh bạn nhận được",
    "cancel" : "Hủy",
    "bindTps" : "Chọn phương thức liên kết tài khoản để bạn có thể chơi game trên nhiều thiết bị!",
    "login" : "Đăng nhập",
    "logout" : "Đăng xuất",
    "bind" : "Tài khoản liên kết",
    "feedback" : "Phản hồi",
    "terms" : "Điều khoản liên quan",
    "tips" : "Nhắc",
    "debindTips" : "Gỡ liên kết có thể sẽ khiến tài khoản của bạn mất dữ liệu, hãy xác nhận lại xem có muốn gỡ liên kết không!",
    "debindText" : "Gỡ liên kết",
    "guestSwitchTips" : "Bạn đang có tài khoản khách đăng nhập, sau khi đăng nhập thì tài khoản khách hiện tại sẽ bị mất, bạn có thực sự muốn đăng nhập?",
    "register" : "Đăng ký",
    "realName" : "Họ tên",
    "enterEmailTips" : "Hãy nhập địa chỉ email",
    "emailVAlidateMsg" : "Lỗi quy cách email",
    "editEmaileTips" : "Hãy nhập email",
    "checkServiceTips" : "Hãy đọc và đồng ý điều khoản bảo mật và chính sách phục vụ!",
    "brithdayValidateTips" : "Hãy chọn ngày sinh chính xác",
    "facebookValidateTips" : "Hãy nhập tài khoản facebook từ 1~60 ký tự",
    "eritOriginPwdTips" : "Hãy nhập mật mã cũ",
    "submitSuccess" : "Nộp thành công",
    "rebindEmail" : "Thay đổi email",
    "bindEmailSuccess" : "Bạn đã liên kết email thành công \$email</br> sủ dụng email đã xác minh, xác minh xong là có thể reset email.",
    "reSetSecurityQuessoon" : "Bạn đã thiết lập câu hỏi an toàn thành công <br/><br/>lựa chọn câu hỏi khác nhau và tiến hành xác minh, sau khi xác minh là có thể reset câu hỏi",
    "canotModifyTips" : "Thông tin cá nhân sẽ không thể thay đổi sau khi giao, có muốn giao?",
    "rebindEmailTips" : "Email của bạn  \$email, hãy nhấp nhận mã xác minh và nhập mã xác minh bạn nhận được",
    "reGetVrfCode" : "Nhận mã xác minh",
    "findPwdWayTips" : "Hãy chọn cách tìm lại sau",
    "emailWay" : "Tìm lại thông qua email an toàn",
    "emailWayTips" : "Bạn nhận được một email xác nhận, có thể thiết lập lại mật mã.",
    "quessionWay" : "Tìm lại thông qua câu hỏi an toàn",
    "quessionWayTips" : "Trả lời câu hỏi an toàn đã được thiết lập là có thể thiết lập lại mật mã",
    "resetPwdBtn" : "Thiết lập lại mật mã",
    "lastStep" : "Bước trước",
    "sendEmailTips" : "Chúng tôi đã gửi thư xác minh tới email của bạn \$email. <br>Hãy nhập mã xác minh bạn nhận được vào trong khung đối thoại.",
    "setNewPwdTips" : "Chúc mừng! <br>Bạn đã có thể thiết lập lại mật mã rồi, hãy nhập mật mã mới của bạn trong khung đối thoại!",
    "termsOfUse" : "Điều khoản phục vụ",
    "copy_success" : "Copy thành công",
    "creatework_create" : "Loại đơn",
    "creatework_createHolder" : "Hãy chọn loại",
    "creatework_title" : "Tiêu đề",
    "creatework_titleHolder" : "Hãy nhập tiêu đề",
    "creatework_detail" : "Chi tiết câu hỏi",
    "creatework_detailHolder" : "Hãy nhập chi tiết câu hỏi trong 200 chữ",
    "creatework_uploadTips" : "Chỉ được upload file định dạng jpg/png, file không quá 5mb",
    "creatework_selectBox_selectTile" : "Loại vấn đề",
    "creatework_goGame" : "Quay về game",
    "creatework_history" : "Lịch sử đơn",
    "mylist_noYet" : "Bạn chưa có ghi chép đơn nào",
    "mywork_solved" : "Vấn đề đã giải quyết? Nhấp vào tôi",
    "mywork_service" : "Đánh giá CSKH",
    "mywork_messageHolder" : "Hãy nhập tin mới",
    "mywork_score" : "Hãy chọn đánh giá",
    "mywork_confirm" : "Xác nhận",
    "creatework_selectBox_selectList3" : "Vấn đề khác",
    "creatework_selectBox_selectList2" : "Vấn đề tài khoản",
    "close" : "Đóng",
    "creatework_gameHolder" : "Hãy chọn game",
    "creatework_serverHolder" : "Hãy chọn Server",
    "contactService" : "Liên hệ CSKH",
    "FAQ" : "FAQ",
    "creatework_game" : "Game:",
    "creatework_server" : "Server:",
    "creatework_role" : "Nhân vật:",
    "selectRoleName" : "Hãy chọn nhân vật",
    "creatework_noRole" : "Chưa tạo nhân vật",
    "creatework_noGame" : "Danh sách game trống",
    "creatework_noServer" : "Danh sách Server trống",
    "termText" : "Tôi đồng ý điều khoản",
    "backLogin" : "Quay về đăng nhập",
    "creatework_roleHolder" : "Hãy chọn nhân vật rồi truy cập",
    "findPwdFailTips" : "Bạn chưa thiết lập câu hỏi an toàn và email bảo mật nên không thể tìm lại thông qua cách này, vui lòng liên hệ CSKH.",
    "payMall" : "Shop Nạp",
    "selectPayment" : "Chọn mức",
    "plzSelectPayWay" : "Hãy chọn cổng của bạn",
    "gainPlus" : "Thêm",
    "gainMorePlus" : "Thêm nhiều mã",
    "gainMostPlus" : "Mã cao nhất",
    "plzSelectPayType" : "Hãy chọn cách Nạp",
    "roleName" : "Tên nhân vật",
    "payWay" : "Cổng Nạp",
    "plzSelectOtherWay" : "Hãy chọn cổng Nạp",
    "payment" : "Số tiền Nạp",
    "compensateTips" : "Phần giá vượt quá thương phẩm sẽ được đền bù [\$gameCode] cho bạn",
    "extaGain" : "Nhận thêm",
    "gameGold" : "Xu Game",
    "compensate" : "Đền bù",
    "payWayPlus" : "Mã cổng",
    "neddPay" : "Cần thanh toán",
    "submitOrder" : "Giao đơn đặt",
    "screenshotTips" : "Nhắc: cắt hình thông tin đơn đặt, để tiện cho việc phản hồi khi gặp vấn đề!",
    "storeFail" : "Nạp thất bại",
    "storeFailTips" : "Lần Nạp này đã thất bại, hãy thử giao lại đơn của bạn hoặc liên hệ CSKH thông qua đơn đặt",
    "storeAcceptance" : "Đang thụ lý",
    "storeSuccessTips" : "Sau khi nạp thành công thì thông thường sẽ nhận được trong 15 phút, hãy đợi chút rồi kiểm tra",
    "orderNumber" : "Số đơn",
    "buyProduct" : "Nạp thương phẩm",
    "transactionAmount" : "Số tiền giao dịch",
    "failReason" : "Nguyên nhân thất bại",
    "payOntherORder" : "Nạp lần nữa",
    "reStore" : "Nạp lại",
    "confirm" : "Xác nhận",
    "switch" : "Đổi tài khoản",
    "completeTips" : "Hãy nhập thông tin cá nhân của bạn, những thông tin sau <mark class=\"yellowMarkColor\"> sẽ không thể sửa đổi sau khi nhập.</mark>.Khi tài tài khoản của bạn bị mất hoặc bị đánh cắp, có thể cung cấp thông tin cá nhân cho bộ phận CSKH để làm căn cứ lấy lại tài khoản.",
    "creatework_selectBox_selectList0" : "Vấn đề game",
    "creatework_selectBox_selectList1" : "Vấn đề Nạp",
    "creatework_selectBox_selectList4" : "Vấn đề dịch",
    "mywork_solvedText" : "Vấn đề đã giải quyết",
    "browserPayErrBtnText" : "Giao dịch gặp vấn đề",
    "browserPaySucBtnText" : "Đã thanh toán thành công",
    "browserPayingTips" : "Bạn đang đến trang thanh toán, <br/>sau khi hoàn thành có thể đóng trang này.",
    "price_list_empty" : "Không có mức giá có thể chọn",
    "pointCardTips" : "Chú ý: Vật phẩm này thanh toán bằng cách nhấp mua thẻ \$paymentAmount",
    "forgetPwd" : "Quên mật khẩu",
    "payCenter" : "Trung Tâm Nạp",
    "willGet" : "Bạn sẽ nhận",
    "goods" : "Thương phẩm",
    "discount" : "Tặng thêm",
    "payDiscount" : "Đền bù nạp",
    "payDiscountTips" : "Bộ phần vượt giá cả của thương phẩm sẽ được đền bù",
    "hasQuestionPlease" : "Nếu có thắc mắc, vui lòng",
    "pwdValidateMsg" : "Mật khẩu phải từ 6-20 ký tự",
    "payWayPlusC" : "Kênh nạp tặng",
    "fwtk" : "Điều khoản phục vụ",
    "yszc" : "Chính sách riêng tư",
    "exchange" : "Trao đổi mã quà tặng",
    "remember" : "Ghi nhớ",
    "thirdInfo" : "Quy tắc tài khoản",
    "thirdInfoContent" : "Vui lòng hoàn thành liên kết tài khoản ở Trung tâm người dùng trong game, sau đó sử dụng tài khoản liên kết đăng nhập.",
    "unLink" : "Tạm thời không thể dùng cách thức này",
    "favour" : "Cất giữ game",
    "goStoreTip" : "Vui lòng chuyển đến trang nạp tiền",
    "go" : "Chuyển",
    "otherLogin" : "Cách thức đăng nhập khác",
    "qrCodeTip" : "Quét mã QR để chơi trên điện thoại",
    "favourTip" : "Cất giữ trang nay vào trình duyệt để thuận tiện cho lần sau chơi",
    "share" : "Chia sẻ với bạn bè",
    "landscapeTip" : "Vui lòng thao tác ở chế độ dọc",
    "leaveTip" : "Bạn thật sự muốn thoắt game?",
    "selectRole" : "Vui lòng chọn nhân vật bạn muốn nạp",
    "selectMoney" : "Vui lòng chọn mục bạn muốn gửi",
    "seletGameInfoFirst" : "Vui lòng chọn game trước",
    "lowerIE" : "Phiên bản trình duyệt IE của bạn quá thấp, hãy truy cấp lại sau khi cập nhật",
    "linkTermText" : "Tôi đồng ý với [Điều khoản dịch vụ] và [Chính sách bảo mật] của {mainHost}",
    "download" : "Tải",
    "favourAndDownloadTip" : "Cất giữ trang này vào trình duyệt hoặc tải về máy tính&lt;br/&gt;Lần sau chơi thuận tiện hơn",
    "payReward" : "Tặng thêm tiền ingame",
    "hasEqualReward" : "2 cách nạp đều có thể hưởng ưu đãi như nạp đầu gấp đôi",
    "payBtnText" : "Thanh toán",
    "storeHoaveReward" : "Ưu đãi nạp",
    "showMorePayWay" : "Xem kênh nạp nhiều hơn",
    "needPaymentCount" : "Mức thanh toán",
    "orderDetail" : "Chi tiết",
    "selectPayWayPlz" : "Ứng dụng",
    "countryCode" : "Mã quốc gia",
    "deleteaccount_title1" : "Xóa thông tin tài khoản",
    "deleteaccount_title2" : "Xin xóa bỏ tài khoản",
    "deleteaccount_step1_1" : "Nếu bạn thực hiện xóa tài khoản, tài khoản của bạn sẽ bị đóng băng 14 ngày. Sau 14 ngày tài khoản của bạn sẽ bị hệ thống xóa vĩnh viễn và cũng không thể dùng tài khoản mọng xã hội đăng nhập.",
    "deleteaccount_step1_2" : "Trong vòng thời gian đóng băng, bạn có thể hủy bỏ yêu cầu xóa bỏ tài khoản thông qua link dưới đây",
    "deleteaccount_step1_3" : "Sau xóa bỏ tài khoản, tất cả dữ liệu của tài khoản sẽ bị xóa hết và không thể tìm lại được, những tổn thất do xóa bỏ tài khoản mang lại cũng không thể được đền bù.",
    "deleteaccount_step1_4" : "Bạn có muốn xóa bỏ tài khoản không?",
    "deleteaccount_step2_1" : "Bạn có muốn xóa bỏ tài khoản hiện tại và tất cả thông tin nhân vật trong game không?",
    "deleteaccount_step2_2" : "Vui lòng nhập Delete\&quot; để hoàn thành xóa bỏ\&quot;",
    "deleteaccount_step3" : "Thao tác xóa bỏ tài khoản sẽ được thực hiện sau 14 ngày từ khi nộp đơn.",
    "accountrecovery_note" : "Lợi nhắc:",
    "accountrecovery_tips" : "Chỉ có thể khôi phục tài khoản trong vòng thời tài khoản bị đóng băng",
    "accountrecovery_Submitted2" : "Đơn xin khôi phục tài khoản đã được nộp, sau nữa đơn xin xóa bỏ tài khoản tương ứng của nhân vật bạn sẽ bị hủy bỏ.",
    "accountrecovery_Failed" : "Nộp thất bại",
    "accountrecovery_Failed_1" : "Tài khoản bạn xin đang ở trạng thái bình thường, có thể đăng nhập game bình thường.",
    "accountrecovery_Failed_2" : "Không thể tìm thấy thông tin nhân vật, hãy nhập lại",
    "accountrecovery_success" : "Khôi phục tài khoản thành công",
    "account_normal" : "Tài khoản bình thường, không cần khôi phục",
    "account_unablerestore" : "Tài khoản đã bị xóa bỏ, không thể khôi phục",
    "accountrecovery_roleHolder" : "Hãy nhập tên nhân vật",
    "accountrecovery_headerTitle" : "Khôi phục tài khoản bị đóng băng",
    "guideTitle" : "Your purchase is not successful. Please contact our customer service.",
    "accountFix" : "Sửa chữa tài khoản",
    "inputAccount" : "Hãy nhập tên tài khoản bạn muốn sửa chữa",
    "applyForAccountFix" : "Xin sửa chữa tài khoản",
    "nonEnterItem" : "Các mục bạn còn thiếu: thời gian tạo, serial number or IMEI thiết bị thường sử dụng, model điện thoại thường sử dụng, hộ chiếu và CMND, email; Vui lòng điền đủ",
    "resetOT" : "Thời gian thiết lập đã quá giờ, hãy gửi lại yêu cầu",
    "addOT" : "Đã quá giờ bổ sung thông tin, vui lòng nộp lại từ đầu",
    "errorPwd" : "Mật khẩu nhất định phải từ 6-20 kí tự, bao gồm chữ viết Hoa, Số, “.”,”_”,”@”",
    "verifyAccount" : "Thiếu thông tin tài khoản, hãy kiểm nghiệm lại",
    "selectRegisterTime" : "Hãy chọn thời gian tạo lập",
    "enterBindEmail" : "Hãy xác định điền chính xác email đã cố định",
    "enterUsedPhoneType" : "Hãy điền model điện thoại thường dùng",
    "enterIdfaGpid" : "Hãy điền thông tin serial number or IMEI thiết bị thường dùng",
    "enterContactEmail" : "Email không hợp lệ, vui lòng điền lại",
    "confirmTermsPrivacy" : "Hãy đồng ý điều khoản và chính sách riêng tư",
    "enterRechargeRemark" : "Hãy nhập lịch sử nạp",
    "uploadImg" : "Hãy tải hình scan CMND rõ nét, size không quá 20M",
    "selectIDType" : "Hãy chọn loại hình CMND",
    "enterIDNum" : "Hãy nhập mã hộ chiếu hoặc số CMND",
    "enterIP" : "Hãy nhập IP nơi tạo",
    "enterQueryNum" : "Hãy nhập tài khoản tra khảo",
    "enterQueryPwd" : "Hãy nhập mật khẩu tra khảo",
    "errorQueryItem" : "Tài khoản tra khảo và mật khẩu không chính xác, vui lòng nhập lại",
    "enterPassword" : "Hãy nhập mật khẩu mới",
    "enterPasswordAgain" : "Hãy nhập lại mật khẩu mới",
    "enterPasswordNonSame" : "Mật khẩu không trùng khớp",
    "enterEmail" : "Hãy nhập email",
    "sendSuccess" : "Email đã gửi thành công",
    "enterCode" : "Hãy nhập mã kiểm nghiệm",
    "errorCode" : "Mã nhập không chính xác",
    "selectQuest" : "Hãy chọn câu hỏi bảo mật",
    "enterAnswer" : "Nhập đáp án",
    "selectDifferQuest" : "Hãy chọn 3 câu hỏi bảo mật, và trả lời",
    "addSuccess" : "Thông tin bổ sung thành công",
    "picFormt" : "Hình phải thuộc dạng file JPG, PNG hoặc GIF",
    "countdownBefore" : "Thời gian thiết lập có hiệu",
    "countdownAfter" : "(Khi thời gian chuyển sang 00:00:00, liên kết sẽ hết hiệu lực, vui lòng nộp lại yêu cầu)",
    "uploadDone" : "Tải lên thành công",
    "uploadFail" : "Tải lên thất bại",
    "applySuccess" : "Nộp thành công",
    "applyFailed" : "Nộp thất bại",
    "resetQuestAlterFailed" : "Chỉnh sửa câu hỏi bảo mật thất bại",
    "resetQuestError" : "Số liệu nhập lỗi",
    "resetQuestNone" : "Chưa tìm thấy đơn hàng",
    "resetQuestAltered" : "Đã chỉnh sửa qua câu hỏi bảo mật",
    "illegalOperation" : "Thao tác phi pháp",
    "queryNotExist" : "Tài khoản tra khảo không tồn tại",
    "queryPasswordError" : "Mật khẩu tra khảo sai",
    "auditing" : "Đang xét duyệt",
    "notPass" : "Không thông qua",
    "suppleInformation" : "Bổ sung thông tin",
    "suppleInformationUnHandle" : "Đã bổ sung thông tin, CSKH chưa xử lý",
    "suppleInformationTimeout" : "Vượt quá thời gian bổ sung thông tin",
    "repairedAccountSuccess" : "Đã hoàn tất chỉnh sửa tài khoản",
    "repairedAccountLost" : "Thao tác chỉnh sửa tài khoản, đã thất bại",
    "loginStateNone" : "Chưa đăng nhập hoặc session đã thất bại",
    "repairedAccountTimeout" : "Đã quá thời gian chỉnh sửa tài khoản",
    "changePasswordSucc" : "Đổi mật khẩu thành công",
    "emailSendFailed" : "Email gửi thất bại",
    "emailSendLimit" : "Email này đã đạt số lần giới hạn nhận mã trong ngày",
    "repairedAccountTimeout2" : "Đã quá thời gian chỉnh sửa tài khoản thao tác phi pháp",
    "emailCodeSended" : "Mã xác nhận email đã gửi",
    "alterSuccess" : "Đổi thành công",
    "questionAlterSuccess" : "Câu hỏi bảo mật đã đổi thành công",
    "username" : "Hãy nhập tên tài khoản",
    "code" : "Hãy nhập mã xác nhận",
    "selectServiceType" : "Chọn loại hình yêu cầu",
    "submitForm" : "Thông qua phương thức nộp đơn để chỉnh sửa tài khoản của bạn",
    "apply" : "Nộp",
    "reviewApplicationStatus" : "Tra cứu tiến độ chỉnh sửa",
    "instantReviewOfTheStatus" : "Thực thi tra cứu tiến độ chỉnh sửa tài khoản",
    "reviewStatus" : "Tiến độ",
    "backToLogin" : "Trở về trang đăng nhập",
    "previous" : "Về trước",
    "applyDesc" : "Những dữ liệu đưới đây hãy vui lòng cung cấp đầy đủ, để chúng tôi có thể giải quyết cho bạn một cách nhanh chóng. * là mục bắt buộc điền vào, nếu chưa có đăng ký mục này, hãy điền vào \"Chưa đăng ký\" hoặc \" Không\".",
    "additionalServices" : "Thêm yêu cầu",
    "resetSecurityEmail" : "Thiết lập lại email bảo mật",
    "resetSecurityQuest" : "Thiết lập lại câu hỏi bảo mật",
    "registrationDate" : "Thời gian tạo",
    "month" : "Tháng",
    "year" : "Năm",
    "emailBound" : "Hãy bổ sung email đã cố định",
    "modelNumber" : "Bổ sung model thiết bị thường dùng;",
    "deviceName" : "Hãy bổ sung model thiết bị thường dùng",
    "provideRecharge" : "Vui lòng cung cấp thông tin chi tiết, thông tin nạp đầy đủ, gồm cả phương thức thanh toán, thời gian, giá trị và các thông tin liên quan, để hỗ trợ việc tra cứu.",
    "selectCountry" : "Chọn khu vực",
    "passportID" : "Hộ chiếu hoặc CMND",
    "upload" : "Tải lên",
    "del" : "Xóa",
    "pleaseUpload" : "Hãy tải hình scan CMND rõ nét, size không quá 20M",
    "uploadAgain" : "Tải lại",
    "enterDesc" : "Nếu còn thông tin chứng minh tài khoản thuộc về bạn, vui lòng điền vào",
    "contactEmail" : "Email liên lạc",
    "applyNoteAttr" : "Nhắc nhở",
    "applyNoteDate" : "Để có thể nhận được thông tin tiến độ kịp thời, vui lòng điền chính xác thông tin email liên lạc",
    "agree" : "Tôi đã đồng ý",
    "UJOYTerms" : "Điều khoản VGM",
    "privacy" : "chính sách riêng tư",
    "reviewStatusOfAccountFix" : "Tra cứu tiến độ chỉnh sửa",
    "enterReviewID" : "Hãy nhập tài khoản tra cứu",
    "enterReviewPwd" : "Hãy nhập mật khẩu tra cứu",
    "review" : "Tra cứu",
    "reviewNoteAttr" : "Nhắc nhở",
    "reviewNoteData" : "Nếu bạn không cẩn thận quên tài khoản, mật khẩu, có thể kiểm tra lại trong thông tin email liên lạc",
    "haveResetInfo" : "Bạn đã thiết lập lại thông tin của mình!",
    "resetProfile" : "Thiết lập lại thông tin của bạn",
    "desc" : "Chúc mừng bạn, thông qua yêu cầu! Hãy thiết lập lại thông tin của  bạn.",
    "changePwd" : "Đổi mật khẩu",
    "resetPwd" : "Thiết lập lại mật khẩu",
    "reset" : "Đổi",
    "enterNewPwd" : "Hãy nhập mật khẩu mới",
    "confirmNewPwd" : "Nhập mật khẩu mới lần nữa",
    "successResetPwd" : "Mật khẩu mới của bạn đã đổi thành công",
    "bindSecurityEmail" : "Cố định email bảo mật",
    "resetPwdDesc" : "Dùng để khi quên mật khẩu hoặc mất tài khoản có thể đổi mật khẩu ngay",
    "bindCommon" : "Cố định",
    "sendCommon" : "Gửi",
    "enterVcode" : "Hãy nhập mã xác nhận nhận được",
    "successResetEmail" : "Email bảo mật của bạn đã được thiết lập thành công",
    "resetQuest" : "Reset câu hỏi bảo mật",
    "resetQuestDesc" : "Dùng khi quên mật khẩu hoặc mất tài khoản có thể nhanh chóng đổi mật khẩu",
    "successResetQuest" : "Câu hỏi bảo mật của bạn đã thiết lập thành công",
    "hide" : "Ẩn đi",
    "addRegisterTime" : "Bổ sung thời gian tạo;",
    "modelNum" : "Hãy bổ sung mã thiết bị thường dùng: IDFA/GPID",
    "registrationIP" : "Bổ sung IP tạo tài khoản;",
    "addRechargeRecord" : "Bổ sung thông tin nạp;",
    "serviceReply" : "Trả lời:",
    "addDataLimitTime" : "Thời gian có hiệu bổ sung thông tin:",
    "addMoreInfo" : "Bổ sung thêm thông tin",
    "applicationSubmit" : "Gửi yêu cầu thành công",
    "underReviewStatus" : "Thông tin của bạn đang xét duyệt, chúng tôi sẽ cố gắng xử lý nhanh nhất có thể, bạn có thể theo dõi tiến độ thông qua phương thức sau:",
    "reviewID" : "Tài khoản tra cứu:",
    "reviePwd" : "Mật khẩu tra cứu:",
    "enterReviewIDNPwd" : "Trên trang tra cứu tiến độ chỉnh sửa tài khoản, nhập thông tin tài khoản, mật khẩu có thể tra xem ngay thông tin tiến độ xử lý",
    "homepage" : "Về trang chủ",
    "checkEmailAttr" : "Nhắc nhở:",
    "checkEmailData" : "Nếu bạn không cẩn thận quên tài khoản, mật khẩu, có thể kiểm tra lại trong thông tin email liên lạc",
    "underReview" : "Thông tin đang kiểm duyệt",
    "underReviewReply" : "Thông tin đang kiểm duyệt, hãy kiên nhẫn đợi, chúng tôi sẽ trả lời bạn nhanh nhất có thể!",
    "failed" : "Xét duyệt chưa thông qua",
    "reason" : "Nguyên nhân: Vì thông tin mà bạn cung cấp ### nên chưa được duyệt, vui lòng cung cấp thông tin chính xác, chúng tôi sẽ tiến hành xử lý nhanh cho bạn, cảm ơn sử hợp tác của bạn, cảm ơn!",
    "underReviewAdd" : "Thông tin đang kiểm duyệt, 1 vài thông tin không đồng nhất hoặc bỏ trống, vui lòng cung cấp thêm thông tin để hỗ trợ chúng tôi xác thật!",
    "addInfoRequired" : "Thông tin cần bổ sung:",
    "dateForAddInfo" : "Thời gian có hiệu lực bổ sung thông tin:",
    "addInfo" : "Thông tin bổ sung",
    "addInfoSubmit" : "Thông tin bổ sung đã nộp, vui lòng đợi xét duyệt!",
    "hasBeenRepaired" : "Đã thành công chỉnh sửa tài khoản",
    "opExpired" : "Thao tác chỉnh sửa tài khoản, đã thất bại",
    "approved" : "Thông qua xét duyệt",
    "haveSubmitted" : "Bạn đã bổ sung qua thông tin",
    "sessionExpired" : "Bạn chưa đăng nhập hoặc session đã thất bại",
    "submitted" : "Bổ sung thành công",
    "addItemRegisterDate" : "Bổ sung email cố định;",
    "addItemDeviceNumber" : "Bổ sung mã thiết bị (serial number/IMEI) thường dùng;",
    "reasonItemPwd" : "CMND không trùng khớp;",
    "addItemIDPhoto" : "Bổ sung thông tin giấy tờ rõ ràng;",
    "idfaTitle" : "Làm cách nào để tìm mã IDFA GDID của thiết bị bạn?",
    "idfaSubTitle1" : "Đối với người dùng IOS- việc tìm kiếm IDFA của thiết bị bạn",
    "idfaSubTitle1Desc1" : "1.Tải ứng dụng <em>MyIDFA</em> tù Appstore.",
    "idfaSubTitle1Desc2" : "2.Mở ứng dụng này và bạn sẽ tìm thấy <em>IDFA</em> thiết bị của bạn.",
    "idfaSubTitle2" : "Đối với người dùng Android- việc tìm kiếm GDID của bạn",
    "idfaSubTitle2Desc1" : "1.tab nút <em>\"Cài Đặt\"</em> của máy",
    "idfaSubTitle2Desc2" : "2.tab biểu tượng <em>“Google”</em> bên dưới trang TÀI KHOẢN",
    "idfaSubTitle2Desc3" : "3.tab <em>\"Quảng cáo\"</em> biểu tượng, và bạn sẽ tìm thấy <em>GPID</em> của bạn.",
    "uploadIDCard" : "Hãy tải hình scan CMND rõ nét, size không quá 20M",
    "uploadTipsBefore" : "Hãy tải lên",
    "uploadTipsAfter" : "hình có size dưới M",
    "submitError" : "Thông tin sai, ví dụ thông tin CMND chưa điền hoặc tài khoản sai đều thuộc thông tin sai",
    "applyLimitError" : "Vượt quá số lần xin trong ngày",
    "applyDisabled" : "Đếm người thời gian nộp (chỉ có phép 10 phút nộp 1 lần)",
    "inputDataError" : "Số liệu chưa điền đầy đủ",
    "dataException" : "Số liệu dị thường",
    "picSizeLimit" : "Size hình giới hạn dưới 5M",
    "picTypeLimit" : "Chỉ có thể tải lên file JPG, PNG, GIF",
    "picNull" : "Hình rỗng",
    "alteredPassword" : "Đã đổi qua mật khẩu",
    "inputError" : "Nhập sai",
    "pwdChangefailed" : "Đổi mật khẩu thất bại",
    "sendEmailCodeDisabled" : "Đếm ngược thời gian nhận mã xác nhận email",
    "alteredEmail" : "Email đã được đổi qua",
    "inputEmailError" : "Nhập email sai",
    "operationFailed" : "Thao tác thất bại",
    "codeNull" : "Bạn chưa nhập mã xác nhận",
    "findPwd" : "Tìm lại mật khẩu",
    "findAccountAndPwd" : "Tìm lại tài khoản và mật khẩu",
    "usualDeviceNum" : "Serial number thiết bị thường dùng: IDFA/GPID",
    "usualPhoneNum" : "Model điện thoại thường dùng",
    "registerTimeError" : "Thời gian tạo không trùng khớp;",
    "bindEMailError" : "Email cố định không trùng khớp;",
    "rechargeRecordError" : "Thông tin nạp không trùng khớp;",
    "registerIPError" : "IP tạo tài khoản không trùng khớp;",
    "deviceNumError" : "Mã thiết bị (serial number/IMEI) thường dùng không trùng khớp;",
    "deviceModelError" : "Model thiết bị thường dùng không trùng khớp;",
    "confirmTerms" : "Vui lòng đồng ý Điều khoản dịch vụ",
    "applyFixAccount" : "Nếu cách trên đây không thể xác nhận được, bạn có thể xin <span>sửa chữa tài khoản</span>",
    "findPwdByFixAccount" : "Tài khoản này chưa cài đặt hòm thư và câu hỏi bảo mật, bạn có thể tìm lại mật khẩu qua chức năng sửa chữa tài khoản",
    "connectFail" : "Disconnected from Google Services, please try again",
    "h5_favour_has_gift" : "Sưu tập game vào trình duyệt để tiện đăng nhập lần sau~Bạn đã nhận thưởng rồi~",
    "h5_favour_get_gift" : "Sưu tập game vào trình duyệt để tiện đăng nhập lần sau, thưởng đã được gửi vào hòm thư của bạn~",
    "h5_get_gift_fault" : "Lĩnh thưởng thất bại, vui lòng thử lại sau hoặc liên hệ CSKH trong game để xử lý",
    "h5_favour_please_select" : "Hãy chọn Máy chủ/Nhân vật trước",
    "h5_favour_login_get" : "Hãy vào game trước rồi sưu tập, để đảm bảo thưởng được gửi tới hòm thư của bạn~",
    "h5_favour_tip" : "Sưu tập game vào trình duyệt để tiện đăng nhập lần sau～",
    "h5_favour_select_serve" : "Please choose server",
    "h5_favour_select_role" : "Please choose character",
    "store_product_paytype_error" : "Thương phẩm bạn đã chọn không thể mua được qua kênh này, hãy thay đổi kênh nạp để mua",
    "SwitchWithThirdWay" : "Thay đổi \${type} để đăng nhập",
    "moreGame" : "Thêm trò chơi",
    "serviceTitle" : "Hỗ Trợ",
    "h5_download_login" : "Vui lòng đăng nhập tài khoản trước!",
    "h5_download_tips" : "Vui lòng mở game qua ứng dụng!",
    "h5_download_repeat_get" : "Bạn đã nhận được gói quà này rồi!",
    "h5_download_succ" : "Vui lòng tải ứng dụng trước!",
    "h5_download_repeat_role" : "Nhân vật này đã bị liên kết",
    "currentLoginAccount" : "Tài khoản đã đang nhập:",
    "fb_canvas_fullscreen" : "Toàn mành hình",
    "fb_canvas_website" : "Trang chủ",
    "fb_canvas_like_share" : "Chia sẻ",
    "fb_canvas_service" : "CS",
    "fb_canvas_login_fail" : "Đăng nhập thất bại",
    "fb_canvas_pay_return" : "Bạn đã hủy bỏ giao dịch lần này",
    "fb_canvas_root_tip" : "Hãy dùng tài khoản Facebook đăng nhập trước",
    "h5_popup_title" : "Payment way",
    "h5_popup_submit" : "Pay",
    "h5_popup_last_used" : "Last used",
    "h5_popup_quit_tips" : "Are you sure to cancel payment",
    "h5_popup_quit_check" : "YES",
    "h5_popup_quit_cancel" : "NO",
    "h5_popup_currency_sign" : "\$",
    "h5_popup_product_empty" : "Product information has not been obtained yet. Please refresh page",
    "h5_popup_server_empty" : "There is no server list yet. Please refresh page",
    "aboutRelevanceAccount" : "Already have an account?",
    "selectLoginType" : "Select a login method",
    "touristDescription" : "If you already have an account, you can log in as a guest and then use the OTP (One-Time Password) feature in the user center to switch accounts. This feature requires the OTP functionality to be set up on your mobile device in the user center.",
    "touristSuggest" : "If you already have an account, you can log in as a guest and then tap the \"Switch Account\" option in the user center. From there, you can log in using a previously bound social media account.",
    "h5_tourist_remenber" : "Remember me for 14 days",
    "account_czsm1" : "1、全てのゲームデータが新しい端末に引き継がれます。OSの異なる端末で引き継ぐことも可能です；",
    "account_czsm2" : "2、引き継ぐ時のパスワードを登録してください。",
    "account_czsm3" : "3、セキュリティ保護のため、",
    "account_wzfdmm" : "大文字と小文字を区別して、6-16文字のパスワードをご入力",
    "account_qzcsrmm" : "再度パスワードをご入力",
    "account_fxyjm" : "引き継ぎコード発行",
    "account_yjmsm1" : "1、タイトル画面にある「ユーザーセンター」をタップ、「切り替え」のページで引き継ぎを行ってください。",
    "account_yjmsm2" : "2、引き継ぎナンバーに使用期限はございません。",
    "account_yjmsm3" : "3、引き継ぎコードは一度しか使えません。再度引き継ぐことができます。",
    "account_yjmsm4" : "4、アカウントを保護するため、引き継ぎコードを他人に教えないようにしてください。",
    "account_fz" : "コピー",
    "account_cxfx" : "新規で発行する",
    "account_czsm4" : "アカウントを連携",
    "account_czsm5" : "してください。",
    "account_yjm" : "引き継ぎコード",
    "account_16wzzj" : "パスワードの長さは6～16文字にする",
    "account_qsrzqdyjmhmm" : "正しい引き継ぎコードとパスワードを入力してください。",
    "account_yj" : "引き継ぎ",
    "accoun_lcsrdmmbyz" : "パスワードの両回の入力は一致しない",
    "deleteaccount_step3_1" : "để hủy bỏ. Bạn có muốn hủy bỏ không?",
    "account_syyjm" : "1. 引き継ぎコードを使ってゲームデータがこの端末に引き継がれます。",
    "account_yjmznsyyc" : "2. 引き継ぎコードは一度しか使えず、再発行することができます。",
    "account_sryjm" : "引き継ぎコードを入力",
    "account_srmm" : "パスワードを入力",
    "h5_header_gift" : "",
    "h5_award_popup_type" : "",
    "h5_award_popup_content" : "",
    "h5_award_popup_code" : "",
    "h5_favour_gift_name" : "",
    "h5_download_gift_name" : "",
    "h5_award_popup_exchange_way" : "",
    "h5_succ_get_gift" : "",
    "h5_exchange_info_title" : "",
    "h5_exchange_info_1" : "",
    "h5_exchange_info_2" : "",
    "h5_check_gift" : "",
    "account_delete_scdqzh" : "Bạn có chắc muốn xóa tài khoản hiện tại và toàn bộ thông tin trong game?",
    "account_delete_fwq" : "Máy chủ",
    "account_delete_zhm" : "Tên nhân vật",
    "account_delete_jshflj" : "Liên kết hồi phục nhân vật",
    "account_delete_qzyzmdxx" : "(Hãy chú ý chữ cái viết hoa hoặc thường)",
    "account_delete_jtbcysxx" : "Nên chụp lại thông tin trên để thuận tiện cho việc tìm lại tài khoản!!",
    "deleteaccount_step3_2" : "Sau 14 ngày tài khoản của bạn sẽ bị hệ thống xóa vĩnh viễn và không có cách nào có thể khôi phục được, tất cả dữ liệu của tài khoản bạn sẽ không tồn tại.\n\nrong vòng 14 ngày sau khi nộp đơn, bạn vẫn có thể thông qua truy cập",
    "h5_guest_login" : "Guest",
    "h5_click_copy" : "Nhấp để copy",
    "questionnaire_btn" : "questionnaire investigation",
    "h5_header_store_text" : "Nạp Thẻ",
    "h5_header_home_text" : "Trang Chủ",
    "h5_check_gift_list_text" : "Chi tiết thưởng",
    "yourServer" : "Máy chủ của bạn",
    "allServer" : "Toàn bộ máy chủ",
    "h5_header_screen" : "Toàn màn hình",
    "h5_verticalTip" : "Vui lòng xoay màn hình để thao tác",
    "h5_third_party_login_tips" : "If you want to log in using a social media account (such as Facebook, Google, Twitter, etc.), you can first log in as a guest and then bind your social media account in the user center.",
    "webStoreUidTitle" : "Uid Tải Khoản",
    "webStoreUidTips" : "Hãy xác nhận UID, Server, Tên nhân vật trước khi chọn vật phẩm nạp",
    "webStoreUidGuide" : "Hướng dẫn lấy uid tài khoản",
    "webStoreUidInputt" : "Nhập uid tài khoản",
    "feedbackTips" : "",
    "recentPlay" : "Đang chơi",
    "moreGames" : "Thêm",
    "previousSelect" : "Lựa chọn lần trước",
    "payAgainBtn" : "Nạp lần nữa",
    "packageTypeName" : "Gói",
    "coinTypeName" : "Nạp lần nữa",
    "cardTypeName" : "Thẻ Tháng",
    "orderNormal" : "Mặc định",
    "orderPriceUp" : "Giá↑",
    "orderPriceDown" : "Giá↓",
    "returnSelectRole" : "Quay về",
    "jiamaInfo" : "Phương thức tính nguyên bảo/kim cương:\nnguyên bảo/kim cương: Số tiền thánh toán* Tỷ lệ Nguyên bảo/kim cương *Tỷ lệ thưởng \n*Lưu ý: Nguyên bảo/Kim cương thêm, không tính vào sự kiện nạp, và EXP VIP*\n*Tựa game được phát hành trên toàn cầu, số tiền thanh toán sẽ tính bằng đô la mỹ. Nếu gặp bất kỳ thắc mắc gì, vui lòng liên lạc CSKH.",
    "lastSelectTag" : "Đã sử dụng trước đây",
    "onestore_subscribe_manage" : "Manage",
    "onestore_subscribe_entrance" : "OneStore Subscription",
    "onestore_subscribe_has_expire" : "Expired",
    "onestore_subscribe_expire_time" : "Expire on \${month}/\${day}/\${year}",
    "onestore_subscribe_privacy" : "About Subscription and Privacy",
    "onestore_subscribe_cancel_subscribe" : "Cancel Subscription",
    "onestore_subscribe_info_title" : "Subscription Info",
    "onestore_subscribe_option_title" : "Options",
    "onestore_subscribe_do_not_subscribe" : "No subscribed items.",
    "onestore_subscribe_get_role_fail" : "Failed to subscribe. Please open this page again in the game.",
    "onestore_subscribe_later" : "Later",
    "onestore_subscribe_confirm" : "Confirm",
    "onestore_subscribe_confirm_cancel" : "Confirm Cancellation",
    "onestore_subscribe_popup_tip" : "If you cancel now, you can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_detail_tip" : "Subscribed item will be renewed on \${month}/\${day}/\${year} (Price: \${prices}/month). Subscription can be canceled 1 day before it expires.",
    "onestore_subscribe_expired_tip" : "Please subscribe the expired item from the in-game Mall/Shop",
    "onestore_subscribe_goon_sub" : "Renew on \${month}/\${day}/\${year}",
    "onestore_subscribe_has_cancel_tip1" : "Subscription canceled. You can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_has_cancel_tip2" : "If you wish to subscribe again. Please do so in the in-game Mall/Shop.",
    "onestore_subscribe_cancel_fail" : "Failed to cancel subscription. Please try again later.",
    "onestore_subscribe_cancel_fail_title" : "Cancel Subscription",
    "apple_deleteaccount" : "Xóa tài khoản",
    "apple_deleteaccount_title" : "Xin xóa tài khoản",
    "apple_deleteaccount_step1_1" : "Vui lòng đọc các nội dung sau:",
    "apple_deleteaccount_step1_2" : "Sau khi bạn xin xóa tài khoản, tài khoản của bạn sẽ bị đóng băng trong 14 ngày.",
    "apple_deleteaccount_step1_3" : "Nếu 14 ngày sau bạn không xin hủy xóa tài khoản, chúng tôi sẽ <span class=\"highlight\">xóa vĩnh viễn </span>tài khoản của bạn. Sau khi xóa vĩnh viễn, bạn sẽ không thể đăng nhập game bằng tài khoản này, tất cả dữ liệu sẽ bị xóa sạch và không thể khôi phục được.",
    "apple_deleteaccount_step1_4" : "Nếu cần hủy liên kết tài khoản mạng xã hội, vui lòng liên lạc CSKH của chúng tôi để thao tác. Nếu không, sau khi tài khoản bị xóa, tài khoản đã liên kết mạng xã hội cũng không thể đăng nhập được.",
    "apple_deleteaccount_step1_5" : "<span class=\"highlight\">Nếu cần thoát hoàn tiền, vui lòng liên lạch CSKH của chúng tôi</span> trước khi xin xóa tài khoản.",
    "apple_deleteaccount_step1_6" : "Trong thời gian đóng băng tài khoản, bạn có thể truy cập link sau đây để hủy xóa tài khoản. Hãy sao chép và lưu lại link trước.",
    "apple_deleteaccount_step2_1" : "Tài sản của bạn trong game đã xử lý xong chưa? Nếu chưa, vui lòng liên lạc CSKH để xử lý và thực hiện thao tác xin xóa tài khoản.",
    "apple_deleteaccount_step2_2" : "Hãy lưu lại thông tin server và nhân vật của bạn, đây là thông tin duy nhất để xác thực khôi phục tài khoản của bạn:",
    "apple_deleteaccount_step2_3" : "Vui lòng nhập \"Delete”\" vào ô nhập liệu để hoàn tất thao tác xóa",
    "apple_deleteaccount_step3_1" : "Bạn đã xin xóa tài khoản, tài khoản sau đây đã bị đóng băng:",
    "apple_deleteaccount_step3_2" : "Thời gian đóng băng tài khoản là 14 ngày, nếu chúng tôi chưa nhận được yêu cầu xin hủy xóa tài khoản, tài khoản sẽ bị xóa vĩnh viễn.",
    "apple_deleteaccount_step3_3" : "Trong 14 ngày, bạn có thể truy cập link sau đây để xin hủy xóa tài khoản",
    "apple_deleteaccount_step4_1" : "Bạn đã xóa tài khoản cũ, và có thể đăng nhập game bằng tài khoản mới",
    "apple_deleteaccount_agree" : "Tôi đã đọc và đồng ý với nội dung trên",
    "apple_deleteaccount_server" : "Server",
    "apple_deleteaccount_roleName" : "Tên nhân vật",
    "copyLink" : "Sao chép",
    "copyTextAndImg" : "Hãy sao chép hoặc chụp ảnh màn hình",
    "copyLinkAndRoleInfo" : "Sao chép link và tên nhân vật",
    "hasCopy" : "Đã sao chép",
    "quickcard_tips" : "Thông tin thẻ tín dụng của bạn đã được Worldpay mã hóa và bảo mật.",
    "quickcard_use_new_card" : "Thêm thẻ",
    "edit" : "Soạn",
    "save" : "Lưu trữ",
    "quickcard_confirm_delete" : "Xóa?",
    "quickcard_popup_tip" : "Nếu bạn muốn sử dụng lại thẻ này sau khi xóa, vui lòng chọn \"Thêm thẻ\".",
    "quickcard_result_tip_one" : "Nếu bạn đã chọn phương thức thanh toán, chúng tôi sẽ thu thập dữ liệu thẻ tín dụng của bạn (**** **** **** 1234) để lưu trữ với hình thức mã hóa.",
    "quickcard_result_tip_two" : "Chúng tôi chỉ lưu trữ các thông tin được mã hóa, và bạn không cần nhập số thẻ trong lần mua tiếp theo.",
    "quickcard_learn_more" : "Tìm hiểu thêm》",
    "quickcard_info_title" : "Hướng dẫn Chứng Chỉ",
    "quickcard_info_tip_one" : "Nhằm mục tích bảo vệ dữ liệu của khách hàng , Visa và Mastercard đã sử dụng \"stored credentials\", mã hóa thông tin thẻ trên đường truyền trong quá trình giao dịch.",
    "quickcard_info_tip_two" : "Khi bạn mua hàng trên trang web của chúng tôi, chúng tôi sẽ thu thập dữ liệu thẻ của bạn (1234 **** **** 1234) với dạng mã hóa. Chúng tôi sẽ giữ các thông tin chi tiết được mã hóa trong 4 năm và sẽ cập nhật thỏa thuận, chính sách bảo mật trên trang web của chúng tôi trong trường hợp có bất kỳ thay đổi nào. Chúng tôi chỉ lưu trữ các thông tin chi tiết được mã hóa để tạo sự thuận tiện cho bạn và bạn không phải nhập số thẻ trong lần mua hàng tiếp theo.",
    "search_product" : "Tìm kiếm theo tên sản phẩm",
    "search_price" : "Tìm kiếm giá cả",
    "price" : "giá cả",
    "product_no_found" : "Thật tiếc, chúng tôi không tìm thấy sản phẩm/giá cả phù hợp",
    "price_no_found" : "Thật tiếc, chúng tôi không tìm thấy sản phẩm/giá cả phù hợp",
    "search_no_found" : "Thật tiếc, chúng tôi không tìm thấy sản phẩm/giá cả phù hợp",
    "product" : "tên sản phẩm",
    "store_tag_hot" : "HOT",
    "store_tag_discount" : "Discount",
    "store_tag_double" : "Double",
    "store_tag_treble" : "Treble",
    "store_tag_sale" : "SALE",
    "store_tag_top_seller" : "TOP SELLER",
    "store_tag_off_10" : "10%OFF",
    "store_tag_off_20" : "20%OFF",
    "store_tag_off_30" : "30%OFF",
    "store_tag_off_40" : "40%OFF",
    "store_tag_off_50" : "50%OFF",
    "store_tag_off_60" : "60%OFF",
    "store_tag_off_70" : "70%OFF",
    "store_tag_off_80" : "80%OFF",
    "store_tag_off_90" : "90%OFF",
    "store_tag_event" : "Event",
    "store_tag_daily" : "Daily",
    "store_tag_weekly" : "Weekly",
    "store_tag_monthly" : "Monthly",
    "subscriptionTypeName" : "subscription",
    "useDoubleSend" : "Use Box Multiplier?",
    "doubleSendInfo" : "Since you used a Box Multiplier, some of the items you purchased were doubled (as shown at the bottom)!",
    "storeRoleTitle" : "Hãy Chọn Nhân Vật",
    "storeSocialLogin" : "Đăng nhập bằng SNS",
    "storeAccountIdLogin" : "Đăng nhập bằng ID",
    "storeInputId" : "Vui lòng nhập ID tài khoản",
    "storeSearch" : "Tìm Kiếm",
    "storeSelectProductTitle" : "Vui lòng chọn vật phẩm muốn mua",
    "storeInputNameSearch" : "Vui lòng nhập tên vật phẩm để tìm kiếm",
    "storeInputPriceSearch" : "Vui lòng nhập giá vật phẩm để tìm kiếm",
    "storeNoFindProduct" : "Không tìm được, vui lòng nhập lại.",
    "storePriceUp" : "Giá ↑",
    "storePriceDown" : "Giá ↓",
    "storeLookDetail" : "Xem chi tiết",
    "storeChangeProduct" : "Đổi vật phẩm",
    "storeWelcome" : "Chào mừng",
    "storeLookMore" : "Thêm",
    "storeHasSelect" : "Đã chọn",
    "storeTotal" : "Tổng",
    "storeExtra" : "Tặng thêm",
    "storeProductDetail" : "Chi tiết",
    "storeUidGuideStep1" : "Nhấp「Thiết lập」-「Thêm」-「Tài khoản」",
    "storeUidGuideStep2" : "Nhập「ID Tài Khoản 」sẽ nạp",
    "storeSelectAndLook" : "Hãy chọn nhân vật để xem chi tiết vật phẩm",
    "storeSwitchWay" : "Đổi cách đăng nhập",
    "type1" : "Daily Sale",
    "type2" : "Hero",
    "type3" : "Battle Gear",
    "type4" : "",
    "type5" : "Chip",
    "type6" : "Nova",
    "type7" : "Resource",
    "type8" : "Build Speedup",
    "type9" : "Rare Items",
    "type10" : "Alliance",
    "type11" : "Diamond",
    "type12" : "Module",
    "type13" : "Cube",
    "type14" : "",
    "type15" : "Nanoweapon",
    "type16" : "Grand Prize",
    "type17" : "",
    "type9999" : "Limited Offer",
    "type10000" : "Gift Center",
    "type10001" : "Holiday Events",
    "typeother" : "Sản phẩm khác",
    "switchChar" : "Đổi nhân vật",
    "howToFindUid" : "How to find my account ID?",
    "choosePayWay" : "Choose a Payment Method",
    "new_apple_deleteaccount_stepsub_title" : "Tự động gia hạn gói",
    "new_apple_deleteaccount_stepsub_1" : "Tài khoản của bạn đã đăng ký tự động gia hạn hàng tháng, vui lòng hủy gói để xóa tài khoản.",
    "new_apple_deleteaccount_stepsub_2" : "Tới hủy",
    "new_apple_deleteaccount_stepsub_later" : "Xóa sau",
    "new_apple_deleteaccount_stepsub_now" : "Xóa ngay",
    "new_apple_deleteaccount_title" : "Xin xóa tài khoản",
    "new_apple_deleteaccount_step1_1" : "Vui lòng đọc các nội dung sau:",
    "new_apple_deleteaccount_step1_2" : "Sau khi nhận yêu cầu xóa tài khoản, chúng tôi sẽ <span class=\"highlight\">xóa vĩnh viễn</span> tài khoản của bạn. Và bạn sẽ không thể đăng nhập game bằng tài khoản này sau khi bị xóa. <span class=\"highlight\">Dữ liệu tài khoản</span> bạn đã liên kết (Tất cả Đơn vị ảo và Vật phẩm ảo trong trò chơi có trong Tài khoản của bạn) sẽ bị mất và sẽ không thể khôi phục được thực hiện theo cùng một mức tương đương tối đa được pháp luật cho phép.",
    "new_apple_deleteaccount_step1_3" : "Nếu cần hủy liên kết tài khoản mạng xã hội, vui lòng liên lạc CSKH của chúng tôi để thao tác. Nếu không, sau khi tài khoản bị xóa, tài khoản đã liên kết mạng xã hội cũng không thể đăng nhập được.",
    "new_apple_deleteaccount_step1_4" : "<span class=\"highlight\">Nếu cần thoát hoàn tiền, vui lòng liên lạch CSKH của chúng tôi</span> trước khi xin xóa tài khoản.",
    "new_apple_deleteaccount_step2_1" : "Tài sản của bạn trong game đã xử lý xong chưa? Nếu chưa, vui lòng liên lạc CSKH để xử lý và thực hiện thao tác xin xóa tài khoản.",
    "new_apple_deleteaccount_step2_2" : "Vui lòng nhập \"Delete\" vào ô nhập liệu để hoàn tất thao tác xóa.",
    "new_apple_deleteaccount_step2_3" : "Vui lòng nhập \"Delete\" vào ô nhập liệu để hoàn tất thao tác xóa",
    "new_apple_deleteaccount_step3_1" : "Bạn đã xin xóa tài khoản, thông tin tài khoản sau đây đã bị xóa:",
    "new_apple_deleteaccount_step3_2" : "Nếu muốn đăng nhập game, vui lòng đăng ký lại tài khoản.",
    "new_apple_deleteaccount_step4_1" : "Bạn đã xóa tài khoản cũ, và có thể đăng nhập game bằng tài khoản mới",
    "currencyTypeName" : "Xu",
    "has_select_product" : "Đã chọn:",
    "n_product" : "\${n}",
    "look_detail_product" : "Xem toàn bộ",
    "limit_buy_product" : "Hạn mua \${n}",
    "limit_order" : "Tối đa thanh toán \${n} món vật phẩm 1 lần",
    "limit_order_remove_tip" : "You have reached the purchase limit for some items in this cart. Do you want to remove them?",
    "paytype_limit" : "This payment method cannot be used to buy some of your items. Please choose a different payment method or try buying them separately.",
    "check_remove_cart" : "Có xác nhận xóa khỏi giỏ hàng",
    "remove_cart" : "Xóa",
    "confirm_product" : "Xác nhận",
    "select_paytype" : "Hãy chọn phương thức thanh toán",
    "cart_is_empty_tip" : "Giỏ hàng trống, hãy chọn vật phẩm",
    "thirty_tip" : "Không nhận được vật phẩm trong 30 phút, vui lòng liên hệ CSKH.",
    "total_n_product" : "Tất cả \${n}",
    "look_detail_of_cart" : "Xem chi tiết",
    "order_detail" : "Item List",
    "total_detail" : "Số lượng:",
    "add_to_cart" : "Thêm vào giỏ hàng",
    "back_to_select" : "Chọn lại",
    "fail_and_later" : "Lỗi thông tin vật phẩm. Vui lòng thử lại sau.",
    "nextStep" : "Tiếp",
    "pnsGameName" : "Puzzles & Survival",
    "enterOfficial" : "Visit \nWebsite",
    "visitorLogin" : "Guest",
    "tokenLogin" : "Mã OTP",
    "fbLogin" : "log in with Facebook",
    "googleLogin" : "Log in with Google",
    "twitterLogin" : "Log in with Twitter",
    "vkLogin" : "Log in with VK",
    "agreementTextStart" : "By logging into the game, you confirm that you have read and agree to the Terms of Service and Privacy Policy.",
    "userCenter" : "User Center",
    "welcomeBack" : "Welcome Back",
    "continueGame" : "START",
    "officialPay" : "Nạp ưu đãi",
    "changeAccount" : "Switch Account",
    "back" : "Back",
    "tokenKey" : "OTP",
    "inputUid" : "Enter your UID",
    "inputToken" : "Enter your OTP",
    "inputCkCode" : "Type the text",
    "enterGame" : "START",
    "tokenTip" : "Protect Your Account With OTP Verification",
    "howToGetToken" : "How to get my one-time password?",
    "getStep1" : "Step 1: Go to Settings > Account > User Center",
    "getStep2" : "Step 2: Tap OTP",
    "getStep3" : "Step 3: Copy and enter your UID and one-time password",
    "copy" : "Copy",
    "lastRefresh" : "Refreshes in:",
    "second" : "s",
    "immediatelyRefresh" : "Refresh Now",
    "frequently" : "Operation too frequent. Please try again later.",
    "loginFail" : "Login failed. Incorrect password.",
    "tokenIntro" : "About One-Time Password (OTP)",
    "tokenIntro1" : "1. One-time passwords expire in 120 seconds. Use them wisely to keep your account safe and secure.",
    "tokenIntro2" : "2. Staff won\'t ask for your one-time password. Please never share or give out your password.",
    "nextStep1" : "Tiếp",
    "couponCanUse" : "Voucher được dùng",
    "couponCanNotUse" : "Voucher không thể dùng",
    "couponHasNoCoupon" : "Không có Voucher",
    "couponUseTip" : "*Mỗi đơn hàng chỉ sử dùng 1 lần",
    "couponValidTime" : "Hiệu lực từ",
    "couponFuilCanUse" : "Áp dụng cho đơn hàng hợp lệ từ  \${price} \${currency}  trở lên",
    "couponNoLimit" : "Áp dụng tất cả sản phẩm",
    "couponAllProductCanUse" : "Áp dụng tất cả sản phẩm",
    "couponPartProductCanUse" : "Cho một sản phẩm nhất định",
    "couponPartPaytypeCanUse" : "Áp dụng cho đơn hàng thanh toán bằng phương thức khuyên dùng",
    "couponOnlyCoinCanUse" : "Áp dụng cho xu game",
    "couponOnlyDiamondCanUse" : "Áp dụng cho kim cương",
    "couponOnlyPackageCanUse" : "Áp dụng cho gói",
    "couponOnlySubCanUse" : "Áp dụng cho sản phẩm đăng ký",
    "couponOnlyDaibiCanUse" : "Áp dụng cho sản phẩm Voucher",
    "couponMaxDiscount" : "Tối đa giảm \${price} \${currency}",
    "couponHasUsed" : "Đã dùng",
    "couponReductionType" : "Voucher Tích Lũy",
    "couponDiscountType" : "Voucher",
    "couponUseNow" : "Dùng ngay",
    "couponHasNoSelect" : "Chưa chọn Voucher",
    "couponHasSelectQuan" : "Đã chọn",
    "couponSubmitTip" : "*Áp mã giảm khi thanh toán",
    "couponCanUseQuan" : "Voucher được chọn",
    "couponOrderTotal" : "Tiền Hàng",
    "couponHasDiscount" : "Giảm",
    "couponPayTotal" : "Tổng Tiền",
    "couponCancel" : "Hủy",
    "couponConfirm" : "Xác nhận",
    "uidLoginName" : "Đăng nhập bằng mã OTP",
    "uidToken" : "Mã OTP",
    "uidInputUid" : "Vui lòng nhập UID",
    "uidInputToken" : "Vui lòng nhập mã OTP",
    "uidInputCode" : "Vui lòng nhập mã xác minh",
    "uidTipTitle" : "Sử dụng mã OTP để bảo vệ tài khoản của bạn",
    "uidTipHowToGet" : "Cách nhận mã OTP?",
    "uidTipStep1" : "Step1: Nhấp vào Thiết lập- Tài khoản- Trung Tâm Người Dùng",
    "uidTipStep2" : "Step2: Nhấp vào mã OTP",
    "uidTipstep3" : "Step3: Sao chép và nhập UID và mã OTP",
    "uidTipIntro1" : "+ Mã OTP chỉ có thể sử dụng một lần và sẽ mất hiệu lực trong 60s.",
    "uidTipIntro2" : "2. Staff won\'t ask for your one-time password. Please never share or give out your password.",
    "couponMyQuan" : "Voucher của tôi",
    "couponSelectPaytypeTip" : "Chọn phương thức thanh toán sẽ hiển thị thông tin ưu đãi",
    "couponSelectCouponTip" : "Chọn vé giảm sẽ hiển thị giá ưu đãi",
    "couponValidQuanTip" : "( \${num} Voucher có thể dùng)",
    "couponLookCart" : "Xem giỏ hàng",
    "couponUnfoldCart" : "Ẩn",
    "couponCoupon" : "Voucher",
    "couponNoUse" : "Chưa dùng",
    "couponSelect" : "Chọn Voucher",
    "couponSureUse" : "Xác nhận dùng",
    "couponReturn" : "Quay về",
    "couponInvalidTime" : "Hết hạn",
    "couponBuyNow" : "Mua ngay",
    "couponAllType" : "Toàn bộ",
    "ztmslgType1" : "Daily Sale",
    "ztmslgType2" : "Hero",
    "ztmslgType3" : "Battle Gear",
    "ztmslgType4" : "",
    "ztmslgType5" : "Chip",
    "ztmslgType6" : "Nova",
    "ztmslgType7" : "Resource",
    "ztmslgType8" : "Build Speedup",
    "ztmslgType9" : "Rare Items",
    "ztmslgType10" : "Alliance",
    "ztmslgType11" : "Diamond",
    "ztmslgType12" : "Module",
    "ztmslgType13" : "Cube",
    "ztmslgType14" : "",
    "ztmslgType15" : "Nanoweapon",
    "ztmslgType16" : "Grand Prize",
    "ztmslgType17" : "Lõi Pha Lê",
    "ztmslgType9999" : "Limited Offer",
    "ztmslgType10000" : "Gift Center",
    "ztmslgType10001" : "Holiday Events",
    "ztmslgTypeother" : "Other",
    "antslgType1" : "Daily Sale",
    "antslgType2" : "Specialized Ant",
    "antslgType3" : "Gear",
    "antslgType5" : "Gene",
    "antslgType6" : "Snail",
    "antslgType7" : "Resources",
    "antslgType8" : "Build & Research",
    "antslgType9" : "Rare Items",
    "antslgType10" : "Alliance",
    "antslgType11" : "Diamond",
    "antslgType12" : "Cell",
    "antslgType13" : "Totem",
    "antslgType9999" : "Limited Offer",
    "antslgTypeother" : "other",
    "typeall" : "Tất cả vật phẩm",
    "vipHead" : "Điểm VIP",
    "vipHead213": "Hội Viên Cao Cấp",
    "vipTitle" : "SK Điểm VIP",
    "nowLevel" : "Cấp VIP hiện tại:",
    "myVipScore" : "Điểm của tôi：",
    "nextLevelNeed" : "(Còn \${num} điểm đạt VIP \${level}）",
    "ruleTitle" : "Thể Lệ",
    "ztmslgVipRule1" : "1．Lịch SK:Năm 2022Tháng 922Ngày00:00(UTC)",
    "ztmslgVipRule2" : "2. Game: Puzzles & Survival",
    "ztmslgVipRule3" : "Mỗi phần quà chỉ duy nhất được nhận 1 lần.",
    "ztmslgVipRule4" : "3. Sự kiện “Đăng nhập nhận Voucher”: Truy cập lần đầu vào giao diện nạp, nhận vé ưu đãi 15%",
    "ztmslgVipRule5" : "4. Sự kiện Điểm VIP: Mua vật phẩm game trên cổng thanh toán chính thức/ \nĐiểm tích đạt cấp tương ứng sẽ nhận được Voucher Đạt Cấp và Voucher Giảm Giá Mỗi Tuần",
    "ztmslgVipRule6" : "5.Chi tiết Phần trăm tiền tệ/điểm tích, vui lòng truy cập link bên dưới",
    "ztmslgVipRule7" : "6. Với đơn sử dụng Phiếu Ưu Đãi, thì điểm sẽ tính theo số tiền thanh toán thực tế",
    "ztmslgVipRule8" : "7. Thời hạn điểm tích lũy là 1 năm, cấp VIP sẽ được tăng theo điểm tích lũy hiện tại",
    "ztmslgVipRule9" : "8. Đạt cấp VIP sẽ được nhận Voucher Cấp VIP& Cấp Mới Mỗi Tuần (00:00 thứ 7 hàng tuần sẽ gửi Voucher)",
    "ztmslgVipRule10" : "9. Đăng nhập để nhận Voucher Mỗi Tuần. Nếu bỏ lỡ sẽ không gửi lại.",
    "ztmslgVipRule11" : "10. Đơn vị tiền tệ Voucher tự động xác nhận theo đơn hàng đã thực hiện cuối cùng. Nếu cần thay đổi đơn vị, vui lòng liên hệ CSKH.",
    "ztmslgVipRule12" : "11. Quy tắc Tặng Voucher:",
    "ztmslgVipRule13" : "12.Team vận hành  Puzzles&survival  có quyền quyết định tất cả và quyết định của team là cao nhất và cuối cùng.",
    "vipLevel" : "Cấp VIP",
    "vipCondition" : "Điều kiện Đạt Điểm",
    "firstSend" : "Lần Đầu Đạt Tặng",
    "weeklySend" : "Voucher",
    "lastAllCoupon" : "Toàn bộ Voucher mốc trước",
    "besides" : "Link:",
    "couponRatio" : "Phần trăm Tiền Tệ/ Point",
    "backToPay" : "Quay về",
    "quanGift" : "VOUCHER",
    "quanGiftTips" : "Có voucher mới, vui lòng nhận!",
    "antslgVipRule1" : "Do tính năng được làm mới, HĐ \"Điểm VIP\" cũ sẽ sớm bị gỡ xuống.",
    "antslgVipRule2" : "Hãy dùng các phiếu ưu đãi từ HĐ \"Điểm VIP\" cũ kịp thời để tránh vượt quá thời hạn sử dụng.",
    "antslgVipRule3" : "Thời gian gỡ: 00:00:00 (UTC) ngày 28/09/2024",
    "antslgVipRule4" : "Sau khi HĐ kết thúc, bạn có thể đến Trung Tâm Hội Viên để trải nghiệm thêm nhiều quyền lợi:",
    "antslgVipRule5" : "Hoàn thành nhiệm vụ để nhận điểm, dùng điểm để đổi thưởng phiếu ưu đãi, đạo cụ! Còn có các quyền lợi thành viên độc quyền, rút thăm trúng thưởng bằng điểm và các hoạt động phúc lợi khác.",
    "antslgVipRule6" : "Vui lòng chờ đón.",
    "dzgVipRule0" : "1．Lịch SK:Năm 2022Tháng 927Ngày00:00(UTC)",
    "dzgVipRule1" : "1. Game: \${gameName}",
    "dzgVipRule2" : "Mỗi phần quà chỉ duy nhất được nhận 1 lần.",
    "dzgVipRule3" : "2. Sự kiện “Đăng nhập nhận Voucher”: Truy cập lần đầu vào giao diện nạp, nhận vé ưu đãi 15%",
    "dzgVipRule4" : "3. Sự kiện Điểm VIP: Mua vật phẩm game trên cổng thanh toán chính thức/ \nĐiểm tích đạt cấp tương ứng sẽ nhận được Voucher Đạt Cấp và Voucher Giảm Giá Mỗi Tuần",
    "dzgVipRule5" : "4.Chi tiết Phần trăm tiền tệ/điểm tích, vui lòng truy cập link bên dưới",
    "dzgVipRule6" : "5. Với đơn sử dụng Phiếu Ưu Đãi, thì điểm sẽ tính theo số tiền thanh toán thực tế",
    "dzgVipRule7" : "6. Thời hạn điểm tích lũy là 1 năm, cấp VIP sẽ được tăng theo điểm tích lũy hiện tại",
    "dzgVipRule8" : "7. Đạt cấp VIP sẽ được nhận Voucher Cấp VIP& Cấp Mới Mỗi Tuần (00:00 thứ 7 hàng tuần sẽ gửi Voucher)",
    "dzgVipRule9" : "8. Đăng nhập để nhận Voucher Mỗi Tuần. Nếu bỏ lỡ sẽ không gửi lại.",
    "dzgVipRule10" : "9. Đơn vị tiền tệ Voucher tự động xác nhận theo đơn hàng đã thực hiện cuối cùng. Nếu cần thay đổi đơn vị, vui lòng liên hệ CSKH.",
    "dzgVipRule11" : "10. Quy tắc Tặng Voucher:",
    "dzgVipRule12" : "11.Team vận hành  \${gameName}  có quyền quyết định tất cả và quyết định của team là cao nhất và cuối cùng.",
    "213dzgVipRule1" : "Do tính năng được làm mới, HĐ \"Điểm VIP\" cũ sẽ sớm bị gỡ xuống.",
    "213dzgVipRule2" : "Hãy dùng các phiếu ưu đãi từ HĐ \"Điểm VIP\" cũ kịp thời để tránh vượt quá thời hạn sử dụng.",
    "213dzgVipRule3" : "Thời gian gỡ: 08:00:00 (UTC) ngày 19/08/2024",
    "213dzgVipRule4" : "Sau khi HĐ kết thúc, bạn có thể đến Trung Tâm Hội Viên để trải nghiệm thêm nhiều quyền lợi:",
    "213dzgVipRule5" : "Hoàn thành nhiệm vụ để nhận điểm, dùng điểm để đổi thưởng phiếu ưu đãi, đạo cụ! Còn có các quyền lợi thành viên độc quyền, rút thăm trúng thưởng bằng điểm và các hoạt động phúc lợi khác.",
    "213dzgVipRule6" : "Vui lòng chờ đón.",
    "getReward" : "Exclusive avatar frames",
    "unbindEntry" : "Liên kết/Gỡ liên kết tài khoản",
    "unbindApply" : "Gỡ liên kết",
    "unbindConfirmTitle" : "Có xác nhận gỡ liên kết?",
    "unbindConfirmTip" : "Bạn xác nhận gỡ liên kết tài khoản bên thứ ba? Điều này có thể sẽ làm mất tiến độ của tài khoản",
    "unbindConfirm" : "Có, vẫn gỡ liên kết",
    "unbindExit" : "Không, thoát ra",
    "unbindSucc" : "Gỡ liên kết thành công",
    "unbindFail" : "Gỡ liên kết thất bại, vui lòng liên hệ CSKH",
    "unbindServiceTitle" : "Yêu cầu gỡ liên kết thủ công",
    "unbindContact" : "Liên hệ CSKH",
    "unbindServiceTip" : "Bạn không đủ điều kiện gỡ liên kết, vui lòng liên hệ CSKH để yêu cầu gỡ liên kết",
    "antslgType15" : "Legacy",
    "shareEventTitle" : "Mời bạn bè</br>Rinh quà khủng",
    "shareRule" : "Quy tắc hoạt động",
    "awardBag" : "Túi thưởng của tôi",
    "initiatorText" : "Tôi là người mời",
    "inviteeText" : "Tôi là người được mời",
    "createCode" : "Tạo mã mời",
    "createCodeTip" : "Nhấp tạo mã mời riêng",
    "createLinkTip" : "Nhấp tạo liên kết mời riêng",
    "copyText" : "Copy",
    "shareCode" : "Chia sẻ mã mời",
    "twShare" : "",
    "fbShare" : "",
    "dcShare" : "",
    "seeAward" : "Tra cứu thưởng",
    "seeAwardTip" : "Hãy vào mục“<span class=\"see-light\">Điểm VIP</span>”-“<span class=\"see-light\">Phiếu Ưu Đãi của tôi</span>”để tra cứu và sử dụng",
    "inviteReward" : "Thưởng mời",
    "inviteRewardTip" : "Không reset tổng mức nạp người được mời",
    "overweightReward" : "Thưởng tăng tiền",
    "resetTip" : "Reset vào 00:00 ngày cuối cùng mỗi tháng",
    "rewardText1" : "Người được mời tích lũy Nạp 9.99USD",
    "rewardText2" : "Người được mời tích lũy Nạp 49.99USD",
    "rewardText3" : "Người được mời tích lũy Nạp 99.99USD",
    "rewardText4" : "Mỗi mời 5 người, nhận được một tấm Phiếu Ưu Đãi 12%!",
    "rewardText5" : "Người được mời Nạp tổng cộng 1000USD, nhận được một tấm Phiếu Ưu Đãi 15%!",
    "invitationList" : "Tổng quan mời",
    "refresh" : "Làm mới",
    "invitedTotal" : "Tổng đã mời: \${total} người",
    "storedTotal" : "Tổng Nạp: \${total} USD",
    "people" : "",
    "invitedPeople" : "Người được mời",
    "invitedTime" : "Thời gian được mời",
    "got" : "Đã đạt",
    "get" : "Chưa đạt",
    "overlay" : "Được cộng dồn",
    "couponText" : "Phiếu Giảm Giá",
    "personalReward" : "Thưởng Nạp cá nhân",
    "personalRewardText1" : "Cá nhân tích lũy Nạp 9.99USD",
    "personalRewardText2" : "Cá nhân tích lũy Nạp 49.99USD",
    "personalRewardText3" : "Cá nhân tích lũy Nạp 99.99USD",
    "inputCode" : "Nhập mã mời",
    "bindCode" : "Liên kết mã mời",
    "bindSucc" : "Đã liên kết",
    "codeTip1" : "Mã mời không tồn tại, vui lòng nhập lại",
    "codeTip2" : "Đã liên kết mã mời",
    "copySucc" : "Copy thành công",
    "awardName" : "Tên thưởng",
    "getTime" : "Thời gian nhận",
    "getCondition" : "Điều kiện nhận",
    "couponText1" : "Phiếu Ưu Đãi 6%",
    "couponText2" : "Phiếu Ưu Đãi 8%",
    "couponText3" : "Phiếu Ưu Đãi 10%",
    "couponText4" : "Phiếu Ưu Đãi 12%",
    "couponText5" : "Phiếu Ưu Đãi 15%",
    "ruleText1" : "1. Lịch SK:Từ 00:00（UTC) ngày 25 tháng 11 năm 2022",
    "ruleText2" : "2. Tham gia game: Puzzles & Survival",
    "ruleText3" : "3. Sự kiện “Chia sẻ nạp cổng chính thức”: Chia sẻ và mời bạn bè sử dụng trang nạp chính thức, nạp tới mức chỉ định là lĩnh thưởng",
    "ruleText4" : "4. Sự kiện \"Thưởng tháng chia sẻ bên thứ ba\" đạt mục tiêu chia sẻ mỗi tháng là nhận thưởng tương ứng, thưởng làm mới mỗi tháng",
    "ruleText5" : "5. Thưởng tháng người chơi mới sau khi mời cần phải Nạp qua bên thứ ba",
    "ruleText6" : "6. Thưởng tháng sẽ cập nhật vào mùng 1 hàng tháng, tiến độ của tháng trước sẽ bị xóa",
    "ruleText7" : "7. Phiếu Giảm Giá cần đăng nhập trang thanh toán bên thứ ba để lấy, hết hạn mà không lấy sẽ không được phát bù",
    "ruleText8" : "8. Loại tiền tệ của Phiếu Giảm Giá là loại tiền tệ của đơn bạn nạp thành công gần nhất, vui lòng liên hệ CSKH nếu bạn muốn đổi loại tiền",
    "ruleText9" : "9. Người chơi hai bên không thể liên kết mã mời đối phương",
    "ruleTableTitle1" : "Quy tắc：",
    "ruleTableTitle2" : "Quy tắc VIP và tặng Phiếu Giảm Giá như hình sau:",
    "ruleTableHead1" : "Tiêu chuẩn nạp",
    "ruleTableHead2" : "Tiêu chuẩn thưởng",
    "ruleTableHead3" : "Thưởng",
    "ruleTableContent1" : "Mời 5 người chơi mới",
    "ruleTableContent2" : "Người chơi liên kết nạp đến 1000 USD",
    "errorTip" : "Thao tác thất bại",
    "eventShareText1" : "Puzzles & Survival: Hoạt động ưu đãi hạn giờ Puzzles & Survival đang diễn ra",
    "eventShareText2" : "Rất nhiều phúc lợi đang đợi bạn tới lấy",
    "cartDoubleTip" : "Không được dùng Vé Gấp Đôi",
    "codeTip3" : "Chưa đăng nhập",
    "codeTip4" : "Thiếu tham số",
    "codeTip5" : "Không thể liên kết với mã mời của chính mình",
    "codeTip6" : "Đã tạo thành mã mời",
    "payWelfare" : "Phúc lợi nạp",
    "wallet" : "Ví tiền",
    "myDiscount" : "Phiếu Ưu Đãi của tôi",
    "knowMore" : "Tìm hiểu thêm",
    "backPay" : "Quay về Nạp",
    "curBalance" : "Số dư hiện tại",
    "pay" : "Nạp",
    "changeCoin" : "Đổi loại tiền",
    "watchDesc" : "Xem chi tiết",
    "getMore" : "Nhận thêm",
    "getDiscount" : "Lấy Phiếu Ưu Đãi",
    "notOpenDiscountQuan" : "Chưa mở hoạt động Phiếu Ưu Đãi, hãy chờ đón",
    "abountZbit" : "Về \${Z-BIT}",
    "remain" : "Số dư:",
    "payRemain" : "Số dư tạm tính sau thanh toán",
    "payRemainExpiry" : "Dự kiến còn lại ${money} (Hết hạn 01/01/2026, dùng ngay!)",
    "balanceNotEnoughExpiry" : "Số dư không đủ (Hết hạn vào 01/01/2026, không hỗ trợ nạp)",
    "balanceNotEnoggh" : "Không đủ số dư, hãy nạp trước",
    "goToPay" : "Tới nạp",
    "chooseOtherPay" : "Chọn cách thanh toán khác",
    "payIntro" : "Giải thích nạp",
    "logRole" : "Đăng nhập",
    "chooseProduct" : "Chọn đồ",
    "meAgree" : "Tôi đã đọc và đồng ý",
    "coinAgreeText" : "",
    "aboutCoin" : "",
    "coinsPayTokenLogin" : "Sử dụng \${Z-BIT} cần tiến hành xác minh lệnh bài động thái",
    "dl3dvnVipRule1" : "1. Game: \${gameName}",
    "dl3dvnVipRule2" : "Mỗi phần quà chỉ duy nhất được nhận 1 lần.",
    "dl3dvnVipRule3" : "2. Sự kiện “Đăng nhập nhận Voucher”: Truy cập lần đầu vào giao diện nạp, nhận vé ưu đãi 15%",
    "dl3dvnVipRule4" : "3. Sự kiện Điểm VIP: Mua vật phẩm game trên cổng thanh toán chính thức/ \nĐiểm tích đạt cấp tương ứng sẽ nhận được Voucher Đạt Cấp và Voucher Giảm Giá Mỗi Tuần",
    "dl3dvnVipRule5" : "4.Chi tiết Phần trăm tiền tệ/điểm tích, vui lòng truy cập link bên dưới",
    "dl3dvnVipRule6" : "5. Với đơn sử dụng Phiếu Ưu Đãi, thì điểm sẽ tính theo số tiền thanh toán thực tế",
    "dl3dvnVipRule7" : "6. Thời hạn điểm tích lũy là 1 năm, cấp VIP sẽ được tăng theo điểm tích lũy hiện tại",
    "dl3dvnVipRule8" : "7. Đạt cấp VIP sẽ được nhận Voucher Cấp VIP&amp; Cấp Mới Mỗi Tuần (00:00 thứ 7 hàng tuần sẽ gửi Voucher)",
    "dl3dvnVipRule9" : "8. Đăng nhập để nhận Voucher Mỗi Tuần. Nếu bỏ lỡ sẽ không gửi lại.",
    "dl3dvnVipRule10" : "9. Đơn vị tiền tệ Voucher tự động xác nhận theo đơn hàng đã thực hiện cuối cùng. Nếu cần thay đổi đơn vị, vui lòng liên hệ CSKH.",
    "dl3dvnVipRule11" : "10. Quy tắc Tặng Voucher:",
    "dl3dvnVipRule12" : "",
    "dl3dvnVipRule13" : "12.Team vận hành  \${gameName}  có quyền quyết định tất cả và quyết định của team là cao nhất và cuối cùng.",
    "codeTip7" : "Người chơi này đã liên kết mã mời của bạn, bạn không thể sử dụng mã mời của cậu ấy để liên kết",
    "ruleText10" : "10. Quyền giải thích cuối cùng của hoạt động này thuộc về Puzzles & Survival.",
    "payCoins" : "Nạp điểm VIP",
    "shareGift" : "Chia sẻ có quà",
    "attentionCoinUse" : "Note: The balance in each currency is handled separately.",
    "noPayWay" : "Vui lòng thay đổi quốc gia hoặc khu vực để thanh toán",
    "dl3dtwVipRule1" : "1. Game: \${gameName}",
    "dl3dtwVipRule2" : "Mỗi phần quà chỉ duy nhất được nhận 1 lần.",
    "dl3dtwVipRule3" : "2. Sự kiện Điểm VIP: Mua vật phẩm game trên cổng thanh toán chính thức/ \nĐiểm tích đạt cấp tương ứng sẽ nhận được Voucher Đạt Cấp và Voucher Giảm Giá Mỗi Tuần",
    "dl3dtwVipRule4" : "3.Chi tiết Phần trăm tiền tệ/điểm tích, vui lòng truy cập link bên dưới",
    "dl3dtwVipRule5" : "4. Với đơn sử dụng Phiếu Ưu Đãi, thì điểm sẽ tính theo số tiền thanh toán thực tế",
    "dl3dtwVipRule6" : "5. Thời hạn điểm tích lũy là 1 năm, cấp VIP sẽ được tăng theo điểm tích lũy hiện tại",
    "dl3dtwVipRule7" : "6. Đạt cấp VIP sẽ được nhận Voucher Cấp VIP& Cấp Mới Mỗi Tuần (00:00 thứ 7 hàng tuần sẽ gửi Voucher)",
    "dl3dtwVipRule8" : "7. Đăng nhập để nhận Voucher Mỗi Tuần. Nếu bỏ lỡ sẽ không gửi lại.",
    "dl3dtwVipRule9" : "8. Đơn vị tiền tệ Voucher tự động xác nhận theo đơn hàng đã thực hiện cuối cùng. Nếu cần thay đổi đơn vị, vui lòng liên hệ CSKH.",
    "dl3dtwVipRule10" : "9. Quy tắc Tặng Voucher:",
    "dl3dtwVipRule11" : "10.Team vận hành  \${gameName}  có quyền quyết định tất cả và quyết định của team là cao nhất và cuối cùng.",
    "eventInviteSucc" : "Mời thành công",
    "eventGainCondition" : "Điều kiện nhận",
    "eventSuccInvite" : "Mời bạn bè thành công",
    "eventInviteGainOne" : "Người được mời \nnạp tích lũy 49.99 USD",
    "eventInviteGainTwo" : "Người được mời \nnạp tích lũy 99.99 USD",
    "eventFriendCode" : "Mã mời bạn bè mà bạn đang có:",
    "eventCheckBind" : "Đồng ý tiến hành liên kết?",
    "eventConfirm" : "OK",
    "eventCancel" : "Hủy",
    "eventBindSucc" : "Liên kết thành công!",
    "eventGainCoupon" : "Chúc mừng bạn được 1 phiếu ưu đãi!",
    "eventLookCoupon" : "Xem phiếu ưu đãi",
    "eventSuccBind" : "Liên kết thành công",
    "recaptchaTip" : "Vui lòng xác minh trước tiên",
    "inputAccountName" : "Vui lòng nhập tài khoản cần tìm lại",
    "pwaPayTip" : "Thanh toán nhanh hơn, trải nghiệm tuyệt vời hơn",
    "pwsInstall" : "Thêm vào giao diện",
    "ztmslgType999" : "Voucher",
    "coinUseTips" : "Voucher sẽ được gửi thông qua thư trong game, có thể mua thương phẩm bất kỳ trong Tiệm Voucher, khi tiêu hao Voucher được nhận thưởng nạp tích lũy",
    "notice" : "Thông báo",
    "popupConfirm" : "Xác nhận",
    "hideWithinWeek" : "Không hiển thị lại trong 7 ngày",
    "ztmslgProductOffTips" : "Gần đây chúng tôi nhận được phản hồi về cập nhật mới của trang nạp từ nhiều người chơi nhiệt tình, chúng tôi rất xem trọng ý kiến của người chơi. Nên quyết định: Hủy thay đổi ra mắt vào ngày 13 tháng 3. Chúng tôi sẽ tiếp tục tối ưu trải nghiệm mua đồ của bạn, cảm ơn bạn đã thông cảm và ủng hộ! Nếu gặp bất kỳ thắc mắc, có thể liên hệ với chăm sóc khách hàng của chúng tôi.",
    "couponTopLimit" : "Hạn mức ưu đãi các loại xu",
    "swsjpVipRule1" : "1．Lịch SK:Năm 2023Tháng 324Ngày00:00(UTC)",
    "swsjpVipRule2" : "2. Game:\${gameName}",
    "swsjpVipRule3" : "Mỗi phần quà chỉ duy nhất được nhận 1 lần.",
    "swsjpVipRule4" : "3. Sự kiện “Đăng nhập nhận Voucher”: Truy cập lần đầu vào giao diện nạp, nhận vé ưu đãi 15%",
    "swsjpVipRule5" : "4. Sự kiện Điểm VIP: Mua vật phẩm game trên cổng thanh toán chính thức/ \nĐiểm tích đạt cấp tương ứng sẽ nhận được Voucher Đạt Cấp và Voucher Giảm Giá Mỗi Tuần",
    "swsjpVipRule6" : "5.Chi tiết Phần trăm tiền tệ/điểm tích, vui lòng truy cập link bên dưới",
    "swsjpVipRule7" : "6. Với đơn sử dụng Phiếu Ưu Đãi, thì điểm sẽ tính theo số tiền thanh toán thực tế",
    "swsjpVipRule8" : "7. Đổi sang điểm tích lũy theo lịch sử nạp",
    "swsjpVipRule9" : "8. Thời hạn điểm tích lũy là 1 năm, cấp VIP sẽ được tăng theo điểm tích lũy hiện tại",
    "swsjpVipRule10" : "9. Đạt cấp VIP sẽ được nhận Voucher Cấp VIP& Cấp Mới Mỗi Tuần (00:00 thứ 7 hàng tuần sẽ gửi Voucher)",
    "swsjpVipRule11" : "10. Đăng nhập để nhận Voucher Mỗi Tuần. Nếu bỏ lỡ sẽ không gửi lại.",
    "swsjpVipRule12" : "11. Đơn vị tiền tệ Voucher tự động xác nhận theo đơn hàng đã thực hiện cuối cùng. Nếu cần thay đổi đơn vị, vui lòng liên hệ CSKH.",
    "swsjpVipRule13" : "12.Team vận hành \${gameName} có quyền quyết định tất cả và quyết định của team là cao nhất và cuối cùng.",
    "beautyVipRule1" : "",
    "beautyVipRule2" : "",
    "beautyVipRule3" : "",
    "beautyVipRule4" : "",
    "beautyVipRule5" : "",
    "beautyVipRule6" : "",
    "beautyVipRule7" : "",
    "beautyVipRule8" : "",
    "beautyVipRule9" : "",
    "beautyVipRule10" : "",
    "beautyVipRule11" : "",
    "antslgType999" : "Voucher",
    "passAskMods" : "Đặt câu hỏi với mod",
    "passAskModsTip" : "Những thắc mắc về game, đều có thể hỏi mod",
    "passService" : "Tư vấn chăm sóc khách hàng",
    "passServiceTip" : "Những vấn đề liên quan đến tài khoản, nạp, vui lòng liên hệ chăm sóc khách hàng",
    "passIKonw" : "Tôi đã hiểu",
    "passGoOn" : "Tư vấn tiếp",
    "voucherTitle" : "Trung tâm nạp chính thức",
    "voucherAddHome" : "Thêm vào giao diện",
    "voucherAddHomeTipOne" : "Nạp nhanh hơn, trải nghiệm tốt hơn",
    "voucherAddHomeTipTwo" : "Nhấp [Chia Sẻ] trong công cụ",
    "voucherAddHomeTipThree" : "và chọn [Thêm vào giao diện]",
    "voucherLoginLook" : "Đăng nhập để xem ưu đãi",
    "voucherSwitchRole" : "Đổi Nhân Vật",
    "voucherCoupon" : "Vé Ưu Đãi",
    "voucherVip" : "Điểm VIP",
    "voucherMoreCoupon" : "Thêm ưu đãi",
    "voucherAccountId" : "ID Tài Khoản",
    "voucherOtp" : "Mã Xác Minh",
    "voucherOtherWayPay" : "Dùng hình thức nạp khác",
    "voucherOtherLoginWay" : "Dùng hình thức đăng nhập khác",
    "voucherCouponActivity" : "Hoạt động ưu đãi",
    "voucherActivityNotBegin" : "Chưa mở hoạt động, vui lòng chờ",
    "voucherGoCommunity" : "Vào nhóm để tìm hiểu thêm phúc lợi nạp",
    "voucherValidTime" : "Có hiệu lực",
    "voucherLimitRegion" : "Chỉ có \${currency} dùng được",
    "voucherLiuyi" : "Không có vé ưu đãi, hãy để ý thông tin hoạt động chính thức",
    "voucherPay" : "Mua Voucher",
    "voucherAbout" : "Về Voucher",
    "voucherChooseWay" : "Chọn hình thức nạp",
    "voucherMoreWay" : "Thêm hình thức nạp",
    "voucherChooseCoupon" : "Chọn Vé Ưu Đãi",
    "voucherHasChoose" : "Đã chọn",
    "voucherMoneyInsufficient" : "Số dư không đủ",
    "voucherContact" : "Số dư không đủ, hãy liên hệ CSKH",
    "voucherCouponTotal" : "Số lượng Vé Ưu Đãi hiện tại",
    "voucherCouponTipGuide" : "Sau khi chọn cách thanh thoán, khi thanh toán chọn dùng Vé Ưu Đãi",
    "voucherPaytypeNotSupport" : "Phương thức thanh toán hiện tại không thể dùng Vé Ưu Đãi",
    "voucherTipSideOne" : "Phiếu Vàng được dùng để đổi toàn bộ quà và dịch vụ trong trò chơi trừ Phiếu Vàng",
    "voucherTipSideTwo" : "Tối đa được ưu đã 15%",
    "voucherYue" : "Số dư",
    "jpUidLoginName" : "",
    "jpUidToken" : "",
    "jpUidInputToken" : "",
    "pnsBook" : "Sổ Tay Sinh Tồn Tận Thế",
    "vipHeadText" : "Chúc mừng bạn đã mở khóa khung avatar VIP độc quyền",
    "vipHeadGetText" : "Nhận Ngay",
    "vipHeadGotText" : "Đã Nhận",
    "vipHeadGetTitle" : "Chốt Nhận",
    "vipHeadGetTip" : "Mỗi tài khoản chỉ được nhận 1 lần, có nhận vào nhân vật này không?",
    "vipHeadAwardText" : "Chỉ Huy Vàng (Vĩnh viễn)",
    "vipHeadGetErrTip1" : "Mỗi tài khoản chỉ được nhận 1 lần, có nhận vào nhân vật này không?",
    "cartGuideTipNew" : "Thanh toán hàng loạt, nhận ưu đãi lớn",
    "newVipTitle" : "VIP Riêng trong Trung Tâm Nạp",
    "newVipLogin" : "Đăng Nhập",
    "newVipNowPoint" : "Điểm hiện tại:",
    "newVipNextLevel" : "Cách cấp sau còn \${point} Điểm",
    "newVipUpgrade" : "Tăng Cấp Ngay",
    "newVipLevel" : "Phúc Lợi Cấp VIP",
    "newVipTip" : "Thưởng Ưu Đãi sẽ làm mới lúc 00:00 UTC Thứ 7 Hàng Tuần, đăng nhập trang nạp sẽ được nhận ngay",
    "newVipWeekly" : "Tăng mỗi tuần",
    "newVipReachPoint" : "Đạt yêu cầu:",
    "newVipRuleInfo" : "Mô tả quy tắc:",
    "pleaseLang" : "Chọn ngôn ngữ",
    "reference" : "Mã giao dịch",
    "saveToNext" : "Lưu để được thanh toán tiếp cho lần sau",
    "cardNum" : "Số thẻ",
    "expireTime" : "Hiệu lực",
    "CVV" : "Mã bảo mật",
    "pleaseCard" : "Chọn loại thẻ tín dụng",
    "howToPay" : "Bạn muốn thanh toán như nào?",
    "checkCard" : "Kiểm tra số thẻ",
    "checkExpiryDate" : "Kiểm tra hiệu lực",
    "checkCVV" : "Kiểm tra mã an toàn",
    "addCard" : "Thêm mới",
    "delete" : "Xóa",
    "deleteCardTips" : "Xóa tài liệu tín dụng đã lưu",
    "confirmDelete" : "Có, xóa",
    "cancelDelete" : "Hủy",
    "checkAllCardMsg" : "Đăng ký thất bại, hãy thử lại hoặc liên hệ CSKH",
    "leaveCreditPageTips" : "Thoát trang sẽ khiến giao dịch thanh toán thất bại, xác nhận thoát ra?",
    "sureToLeave" : "Xác Nhận",
    "continueToPay" : "Thanh Toán Tiếp",
    "pushTest" : "Kiểm tra thông báo",
    "getNoticication" : "Thiết bị không nhận được thông báo?",
    "waitCheckResult" : "Vui lòng chờ kết quả kiểm tra, để định vị nguyên nhân",
    "hadAbnormal" : "Kiểm tra được bất thường, dẫn đến không nhận được thông báo.",
    "clickIntro" : "Hãy nhấn xem bất thường để xem hướng dẫn xử lý",
    "networkCheck" : "Kiểm tra môi trường mạng",
    "noticeAuthorityCheck" : "Kiểm tra quyền thông báo",
    "noticeBtnCheck" : "Kiểm tra cột tắt bật thông báo",
    "gmsCheck" : "Kiểm tra server GMS",
    "batteryCheck" : "Kiểm tra danh sách tối ưu pin",
    "pushServiceCheck" : "Kiểm tra thông báo dịch vụ",
    "reCheck" : "Kiểm tra lại",
    "noNoticeAuthorityTip" : "Thiết bị chưa cho phép quyền thông báo game, đến cài đặt hệ thống-thông báo, chọn trò chơi và mở quyền thông báo.",
    "noNoticeBtnTip" : "Chưa bật thông báo game, đến cài đặt hệ thống mở bật thông báo game.",
    "noBatteryTip" : "Game trong danh sách tối ưu pin, có thể không nhận được thông báo. Đến cài đặt hệ thống - pin - tối ưu pin, thêm vào whitelist.",
    "noPushServiceTip" : "Kết nối thông báo dịch vụ thất bại, hãy nhấn [kết nối] để tiến hành liên kết",
    "noNetworkTip" : "Mạng không ổn định, hãy kết nối mạng tốt hơn rồi thử lại",
    "noGmsTip" : "Thiết bị không hỗ trợ dịch vụ GMS, hãy đổi thiết bị có thể hỗ trợ GMS đăng nhập để nhận thông báo",
    "pushConnectFail" : "Kết nối thông báo dịch vụ thất bại",
    "pushConnectSucc" : "Kết nối thông báo dịch vụ thành công",
    "noGetPushTitle" : "Nếu vẫn chưa nhận được thông báo game, hãy kiểm tra theo bước sau:",
    "noGetPushContOne" : "1.Đăng nhập lại vào tài khoản game sau khi thiết bị thoát game;",
    "noGetPushContTwo" : "2.Nhấn [Kiểm tra thông báo] sẽ tự động kiểm tra, hãy để ý thiết bị có nhận được thông báo chưa.",
    "noGetPushContThree" : "3.Nếu thiết bị nhận được thông báo, nhưng không nhận được thông báo game, đến game-thiết bị-thông báo, kiểm tra mục liên quan đã bật chưa.",
    "noGetPushContFour" : "4.Nếu theo thao tác trên vẫn chưa nhận được thông báo, hãy liên hệ CSKH xử lý.",
    "getPushSucc" : "Thiết bị đã nhận thành công 1 dòng thông báo, chức năng bình thường!",
    "allCheckSucc" : "Mọi kiểm tra đều bình thường",
    "pushCheck" : "Kiểm tra thông báo",
    "useDirectPay" : "Dùng thanh toán nhanh",
    "paypalFraudnetInfo" : "Thông tin thanh toán được bảo vệ công cụ kiểm soát của Paypal",
    "goToSetting" : "Đến cài đặt",
    "retry" : "Thử Lại",
    "connect" : "Liên kết",
    "canRebind" : "Sau khi gỡ liên kết, bạn có thực hiện liên kết lại",
    "agreePlatform" : "Tôi đã đồng ý \${service} và \${privite}",
    "sendGameNews" : "Đăng ký tin tức trò chơi mới nhất",
    "canNotBindEmail" : "Sau khi gỡ liên kết, sẽ không thể đăng nhập bằng hộp thư này",
    "canNotBindPhone" : "Sau khi gỡ liên kết, sẽ không thể đăng nhập bằng số điện thoại này",
    "canChangeByEmail" : "Có thể đăng nhập vào thiết bị khác nhau bằng hộp thư này",
    "canChangeByPhone" : "Có thể đăng nhập vào thiết bị khác nhau bằng số điện thoại này",
    "loginSucc" : "Đăng nhập thành công",
    "phoneHadBind" : "Đã liên kết số điện thoại của tài khoản này, xác nhận đăng nhập ngay",
    "emailHadBind" : "Đã liên kết tài khoản hộp thư này, xác nhận đăng nhập ngay",
    "phoneNotBind" : "Tài khoản chưa liên kết số điện thoại này, xác nhận tạo tài khoản mới",
    "emailNotBind" : "Tài khoản chưa liên kết hộp thư này, xác nhận tạo tài khoản mới",
    "emailAccount" : "Tài khoản hộp thư",
    "phoneAccount" : "Tài khoản số điện thoại",
    "phoneInputError" : "Lỗi quy cách số điện thoại",
    "registerNewAccount" : "Đăng ký tài khoản mới",
    "secureTip" : "Cảnh báo Nạp Lậu",
    "toTop" : "Gim",
    "createNewWork" : "Tạo đơn mới",
    "serviceEvaluate" : "Đánh giá CSKH",
    "emailRemind" : "Hộp thư nhắc nhở",
    "isAgreeService" : "Bạn có hài lòng về dịch vụ của chúng tôi không?",
    "thankEvaluateTop" : "Cảm ơn đánh giá quy báu của bạn!",
    "inputValidEmail" : "Vui lòng nhập email chính xác",
    "replyWillRemind" : "Sau khi CSKH trả lời, email của bạn sẽ nhận được thư nhắc nhỏ. Nếu muốn hủy chức năng này hãy nhấp lại chức năng nhắc nhở lần nữa.",
    "isCancelEmailRemind" : "Có hủy nhắc nhở không? Sau khi hủy sẽ không thể nhận thư!",
    "reconfirmEmail" : "Vui lòng xác nhận email của bạn đã chính xác chưa?",
    "confirmCanSubmit" : "Sau khi xác nhận sẽ gửi đơn",
    "serviceWillReply" : "Sau khi CSKH trả lời sẽ phản hồi qua hộp thư",
    "cancelEmailRemind" : "Bạn muốn hủy \"Hộp thư nhắc nhở\"?",
    "yes" : "Có·",
    "no" : "Không",
    "inputWorkSearch" : "Hãy nhập từ khóa",
    "loading" : "Đang tải",
    "loadingError" : "Tải thất bại, hãy tải lại...",
    "noMore" : "Không còn nhiều hơn",
    "cancelToTop" : "Hủy gim lên",
    "evaluateOne" : "Rất không hài lòng",
    "evaluateTwo" : "Không hài lòng",
    "evaluateThree" : "Thường",
    "evaluateFour" : "Hài lòng",
    "evaluateFive" : "Rất hài lòng",
    "confirmDelWorkTop" : "Xác nhận xóa đơn?",
    "reRemindEmail" : "Muốn nhắc nhở lại qua thư? Bạn có thể nhấp [Nhắc nhở thư].",
    "confirmWillReply" : "Xác nhận xong, sau khi CSKH trả lời sẽ phản hồi qua hộp thư",
    "thankEvaluateBottom" : "Đánh giá của bạn là động lực để chúng tôi nâng cao dịch vụ!",
    "confirmDelWorkBottom" : "Sau khi xóa không thể trả lời!",
    "morePurchaseWay" : "Nhiều hình thức nạp",
    "purchaseNeed" : "Mua vật phẩm cần:",
    "videoUploadSucc" : "Tải video lên thành công",
    "videoUploadFail" : "Tải video lên thất bại",
    "videoUploadLimit" : "Chỉ được tải video mp4, video không được quá 400mb, thời gian không quá 2p",
    "imageUploadSucc" : "Tải hình ảnh lên thành công",
    "imageUploadFail" : "Tải hình ảnh lên thất bại",
    "uploading" : "Đang tải",
    "smartOrderCreate" : "Tạo giao dịch ngay",
    "smartOrderSearch" : "Tìm kiếm",
    "smartOrderComing" : "Vui lòng chờ",
    "smartOrderContactService" : "Liên hệ CSKH",
    "smartOrderDetector" : "Trợ giúp",
    "smartOrderDetect" : "Kiểm tra",
    "smartOrderDetecting" : "Đang kiểm tra",
    "smartOrderDetectTip" : "Kiểm tra được lỗi bạn gặp phải trong quá trình chơi, hãy nhấp kiểm tra, chúng tôi sẽ giúp bạn định vị vấn đề.",
    "smartOrderDetectTip2" : "Đã giúp bạn định vị được lỗi, sau khi gửi đơn, chúng tôi sẽ giúp bạn xử lý!",
    "smartOrderSubmit" : "Gửi",
    "smartOrderIKnow" : "Tôi biết rồi",
    "smartOrderConfirm" : "Xác nhận",
    "smartOrderLook" : "Xem",
    "smartOrderIsHelp" : "Tài liệu này có giúp ích cho bạn không?",
    "smartOrderInputQuestion" : "Hãy nhập vấn đề của bạn",
    "smartOrderPleaseInpt" : "Hãy nhập",
    "smartOrderPleaseChoose" : "Hãy chọn",
    "smartOrderStoreTime" : "Thời gian nạp",
    "smartOrderInputOrder" : "Hãy nhập mã giao dịch",
    "smartOrderInputPrice" : "Hãy nhập số tiền giao dịch",
    "smartOrderNeedHelp" : "Xin chào, tôi có thể giúp gì được cho bạn?",
    "smartOrderLookHelpTip" : "Bạn có thể xem cách giải quyết thường gặp",
    "smartOrderNoResult" : "Không tìm thấy kết quả, hãy thử tìm kiếm nội dung khác",
    "smartOrderUpdateTime" : "Thời gian chỉnh sửa mới",
    "smartOrderSelectStoreTime" : "Hãy chọn thời gian nạp",
    "smartOrderAtlestChoose" : "Hãy nhập tối thiểu một mục",
    "pwaInstallAward" : "Thêm vào màn hình chính",
    "getMasonry" : "Nhận KC",
    "addToDrawerVisit" : "Thêm đến màn hình để tiện truy cập",
    "immeAddToGet" : "Thêm ngay, nhận thưởng hạn giờ",
    "add" : "Thêm",
    "talkNextTime" : "Để lần sau",
    "chooseRoleGetGift" : "Chọn nhân vật để nhận thưởng",
    "getGiftSuccess" : "Nhận thành công, hãy xem thưởng trong game",
    "dmaTitle" : "Quảng cáo tùy chỉnh",
    "newAdd" : "Thêm mới",
    "smartDelete" : "Xóa",
    "wordLengthTip" : "(0-600 từ)",
    "areaLimitSwitchRegion" : "Đổi khu",
    "areaLimitCurrentRegionCurrency" : "Khu hiện tại và loại tiền thanh toán",
    "areaLimitRegion" : "Khu:",
    "areaLimitCurrency" : "Loại tiền thanh toán:",
    "areaLimitNote" : "Chú ý:",
    "areaLimitSwitchLimitation" : "Mỗi tài khoản chỉ được đổi một khu mỗi năm",
    "areaLimitPostSwitchCoupon" : "Sau khi hoàn thành đổi, phiếu ưu đãi mới nhận sẽ gửi theo loại tiền tương ứng của khu mới.",
    "areaLimitRemainingSwitches" : "Lượt còn lại hiện tại: \${times}",
    "areaLimitNoRemainingSwitches" : "Không còn lượt",
    "areaLimitUnableToSwitchThisYear" : "Không thể điều chỉnh năm nay",
    "areaLimitCannotSwitch" : "Không thể điều chỉnh",
    "areaLimitNavigateToSwitch" : "Đến điều chỉnh",
    "areaLimitConfirmSwitch" : "Xác nhận điều chỉnh",
    "areaLimitPreSwitchRegionCurrency" : "Khu vực và loại tiền thanh toán trước khi đổi",
    "areaLimitPostSwitchRegionCurrency" : "Khu vực và loại tiền thanh toán sau khi đổi",
    "areaLimitPostSwitchRestriction" : "Sau khi đổi thành công, năm nay không thể đổi tiếp khu thanh toán",
    "areaLimitUnusedZBitWarning" : "Bạn còn chưa dùng Z-Bit, sau khi đổi khu có thể sẽ không dùng được",
    "areaLimitConfirm" : "Xác nhận",
    "areaLimitCancel" : "Hủy",
    "areaLimitInconsistencyWarning" : "Khu truy cập và khu thanh toán của bạn không giống nhau",
    "areaLimitPromptToSwitch" : "Có cần đổi khu không?",
    "areaLimitEnterZipCode" : "*Please enter your zipcode",
    "areaLimitEnterInvalid" : "Zipcode is invalid, please re-enter",
    "areaLimitTaxRateTips" : "Depending on your location, the tax rate may vary, the payment amount shall prevail",
    "areaLimitInfoCollect" : "For information collection protection, please refer to the Privacy Policy",
    "getAward" : "Nhận thưởng",
    "selectProductTitle" : "Chọn sản phẩm",
    "hotSuggest" : "Đề xuất bán chạy",
    "inputKeywordSearch" : "Nhập từ khóa hấp dẫn",
    "lookProductContent" : "Xem nội dung sản phẩm",
    "popupClose" : "Đóng",
    "productSwitch" : "Đổi sản phẩm",
    "confirmBuy" : "Xác nhận mua",
    "thinkLater" : "Lần sau",
    "areaLimitConfirmRegion" : "Xác nhận khu vực",
    "areaLimitContinuePay" : "Tiếp tục thanh toán",
    "areaLimitSwitchLimitationTwice" : "Mỗi tài khoản được đổi khu vực hai lần mỗi năm",
    "dtmslgVipRule1" : "1. Game: \${gameName}",
    "dtmslgVipRule2" : "Mỗi phần quà chỉ duy nhất được nhận 1 lần.",
    "dtmslgVipRule3" : "2. Sự kiện Điểm VIP: Mua vật phẩm game trên cổng thanh toán chính thức/ nĐiểm tích đạt cấp tương ứng sẽ nhận được Voucher Đạt Cấp và Voucher Giảm Giá Mỗi Tuần",
    "dtmslgVipRule4" : "3.Chi tiết Phần trăm tiền tệ/điểm tích, vui lòng truy cập link bên dưới",
    "dtmslgVipRule5" : "4. Với đơn sử dụng Phiếu Ưu Đãi, thì điểm sẽ tính theo số tiền thanh toán thực tế",
    "dtmslgVipRule6" : "5. Thời hạn điểm tích lũy là 1 năm, cấp VIP sẽ được tăng theo điểm tích lũy hiện tại",
    "dtmslgVipRule7" : "6. Đạt cấp VIP sẽ được nhận Voucher Cấp VIP& Cấp Mới Mỗi Tuần (00:00 thứ 7 hàng tuần sẽ gửi Voucher)",
    "dtmslgVipRule8" : "7. Đăng nhập để nhận Voucher Mỗi Tuần. Nếu bỏ lỡ sẽ không gửi lại.",
    "dtmslgVipRule9" : "8. Đơn vị tiền tệ Voucher tự động xác nhận theo đơn hàng đã thực hiện cuối cùng. Nếu cần thay đổi đơn vị, vui lòng liên hệ CSKH.",
    "dtmslgVipRule10" : "9. Quy tắc Tặng Voucher:",
    "dtmslgVipRule11" : "10.Team vận hành  \${gameName}  có quyền quyết định tất cả và quyết định của team là cao nhất và cuối cùng.",
    "dtmslgType10010" : "Ưu Đãi Ngày",
    "dtmslgType10020" : "Cung Ứng Giới Hạn",
    "dtmslgType10030" : "Anh Hùng",
    "dtmslgType10040" : "Trang bị chiến đấu",
    "dtmslgType10050" : "Bùa",
    "dtmslgType10060" : "Totem",
    "dtmslgType10070" : "Đá Thánh",
    "dtmslgType10080" : "Rồng Lớn",
    "dtmslgType10090" : "Tài Nguyên",
    "dtmslgType10100" : "Nghiên Cứu Xây Dựng",
    "dtmslgType10110" : "Vật Phẩm Hiếm",
    "dtmslgType10120" : "Vũ Trang Số Phận",
    "dtmslgType10130" : "Kim Cương",
    "dtmslgType10140" : "Voucher",
    "dtmslgType2" : "Gói HĐ",
    "dtmslgType3" : "Trung Tâm Phúc Lợi",
    "dtmslgType4" : "Gói Kích Hoạt",
    "dtmslgType5" : "Gói Giao Diện",
    "dtmslgType20010" : "Gói Black Friday",
    "dtmslgType20021" : "Đại Lễ 5 Ngày",
    "dtmslgTypeother" : "Other",
    "rightsIntro" : "",
    "213RightsIntro": "Do tính năng được làm mới, HĐ \"Điểm VIP\" cũ sẽ sớm bị gỡ xuống.<br/>\n" +
        "Hãy dùng các phiếu ưu đãi từ HĐ \"Điểm VIP\" cũ kịp thời để tránh vượt quá thời hạn sử dụng.<br/>\n" +
        "Thời gian gỡ: 08:00:00 (UTC) ngày 19/08/2024<br/>\n" +
        "Sau khi HĐ kết thúc, bạn có thể đến Trung Tâm Hội Viên để trải nghiệm thêm nhiều quyền lợi:<br/>\n" +
        "Hoàn thành nhiệm vụ để nhận điểm, dùng điểm để đổi thưởng phiếu ưu đãi, đạo cụ! Còn có các quyền lợi thành viên độc quyền, rút thăm trúng thưởng bằng điểm và các hoạt động phúc lợi khác.<br/>\n" +
        "Vui lòng chờ đón.",
    "263RightsIntro": "Do tính năng được làm mới, HĐ \"Điểm VIP\" cũ sẽ sớm bị gỡ xuống.<br/>\n" +
        "Hãy dùng các phiếu ưu đãi từ HĐ \"Điểm VIP\" cũ kịp thời để tránh vượt quá thời hạn sử dụng.<br/>\n" +
        "Thời gian gỡ: 00:00:00 (UTC) ngày 28/09/2024<br/>\n" +
        "Sau khi HĐ kết thúc, bạn có thể đến Trung Tâm Hội Viên để trải nghiệm thêm nhiều quyền lợi:<br/>\n" +
        "Hoàn thành nhiệm vụ để nhận điểm, dùng điểm để đổi thưởng phiếu ưu đãi, đạo cụ! Còn có các quyền lợi thành viên độc quyền, rút thăm trúng thưởng bằng điểm và các hoạt động phúc lợi khác.<br/>\n" +
        "Vui lòng chờ đón.",
    "goToRights" : "Đến Trung Tâm Hội Viên",
    "oldVipIntro" : "Hãy dùng các phiếu ưu đãi từ HĐ \"Điểm VIP\" cũ kịp thời để tránh vượt quá thời hạn sử dụng.",
    "pwa-20001" : "Hãy đăng nhập trước",
    "pwa-20002" : "Sai tham số",
    "pwa-20003" : "Chưa liên kết nhân vật",
    "pwa-20004" : "Gửi thưởng thất bại, vui lòng thử lại hoặc liên hệ CSKH",
    "pwa-20005" : "Bạn đã lấy Gói quà này",
    "pwa-20100" : "Sự kiện chưa bắt đầu",
    "pwa-20101" : "Sự kiện đã kết thúc",
    "pwa-20102" : "Chưa đến thời gian nhận thưởng",
    "pwa-20103" : "Đã hết thời gian nhận thưởng",
    "pwa-1001" : "Thao tác dồn dập",
    "pwaCommon" : "Vui lòng thử lại sau",
    "zipCodeSwitchZipCode" : "Switch zipcode",
    "zipCodeState" : "state",
    "zipCodeRate" : "rate",
    "-" : "-",
    "officialStore": "Trung tâm nạp chính thức",
    "headerSafeTip": "An toàn không rủi ro Nhận tiền nhanh",
    "safeChecking": "....đang kiểm tra môi trường nạp hiện tại",
    "safeChecked": "An toàn, yên tâm sử dụng",
    "riskChecked": "Tồn tại rủi ro, vui lòng thao tác cẩn thân",
    "footerSafeTitle1": "An toàn",
    "footerSafeTitle2": "Tiện lợi",
    "footerSafeTitle3": "Lợi ích cao",
    "footerSafeTitle4": "Hiệu quả cao",
    "footerSafeContent1": "Trung tâm nạp chính thức",
    "footerSafeContent2": "Ủng hộ nhiều hình thức nạp khác nhau",
    "footerSafeContent3": "Ưu đãi giảm giá, nhiều phúc lợi hạn giờ",
    "footerSafeContent4": "Nhanh chóng nhận tiền, không trì hoãn",
    "limitedTimeActivityTitle" : "Phúc Lợi Hạn Giờ",
    "limitedTimeActivityTime" : "Thời gian HĐ:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivityTaskProcess" : "(Hiện tại \${curPay}/\${targetPay})",
    "limitedTimeActivityRateTips" : "(Tỷ giá có sự biến động nhất định, vui lòng lấy tỷ giá hiển thị trên trang này làm chuẩn)",
    "limitedTimeActivityNotAchieve" : "Chưa hoàn thành",
    "limitedTimeActivityClaim" : "Nhận",
    "limitedTimeActivityClaimed" : "Đã nhận",
    "limitedTimeActivityTimeLeft" : "Thời hạn: \${days}d \${hours}:\${minutes}:\${seconds}",
    "limitedTimeActivityRecord" : "Lịch Sử Nhận",
    "limitedTimeActivityAward" : "Thưởng",
    "limitedTimeActivityGotTime" : "Thời gian nhận",
    "limitedTimeActivityGotRole" : "Nhân vật nhận",
    "limitedTimeActivityRule" : "Quy tắc hoạt động",
    "limitedTimeActivity285Rule1" : "1. Thời gian HĐ:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivity285Rule2" : "2. Thời gian HĐ, hoàn thành nhiệm vụ hạn giờ nhận thưởng, nhiệm vụ hàng tuần và nhiệm vụ hàng tháng:",
    "limitedTimeActivity285Rule3" : "(1) Nhiệm vụ hàng tuần: Mỗi tài khoản được hoàn thành 1 lần, cài lại vào 0h00 thứ 2.",
    "limitedTimeActivity285Rule4" : "Nhiệm vụ đăng nhập hàng tuần: Trong thời gian giới hạn, hoàn thành 1 lần đăng nhập trang nạp chính thức.",
    "limitedTimeActivity285Rule5" : "Hoàn thành 1 lần nạp mốc bất ký: Trong thời gian giới hạn, tại giao diện nạp chính thức, hoàn thành 1 gói nạp mốc bất kỳ sẽ hoàn thành nhiệm vụ.",
    "limitedTimeActivity285Rule6" : "(2) Nhiệm vụ hàng tháng: Mỗi tài khoản được hoàn thành 1 lần, cài lại vào 0h00 mùng 1 hàng tháng.",
    "limitedTimeActivity285Rule7" : "Nhiệm vụ đăng nhập: Trong thời gian giới hạn, hoàn thành 1 lần đăng nhập trang nạp chính thức.",
    "limitedTimeActivity285Rule8" : "Nhiệm vụ tích lũy nạp: Trong thời gian giới hạn, tại giao diện nạp chính thức, tích lũy nạp đạt mốc nhiệm vụ sẽ được nhận thưởng 1 lần.",
    "limitedTimeActivity285Rule9" : "Chú ý: Do thời gian hoạt động dài, tỷ giá có thể sẽ biến động, số tiền nạp vui lòng lấy trên trang này làm chuẩn.",
    "limitedTimeActivity285Rule10" : "3. Trước khi nhận thưởng, cần chọn 1 nhân vật để nhận, nhận xong xem thưởng trong game.",
    "limitedTimeActivityClaimAward" : "Nhận thưởng",
    "limitedTimeActivityConfirmGot" : "Xác nhận nhận",
    "limitedTimeActivityGetSucc" : "Nhận thành công",
    "limitedTimeActivityGetFail" : "Nhận thất bại, vui lòng thử lại hoặc liên hệ CSKH",
    "limitedTimeActivityFrequent" : "Vui lòng không thao tác liên tục",
    "limitedTimeActivityLoginFirst" : "Hãy đăng nhập",
    "limitedTimeActivityWrongParam" : "Tham số lỗi",
    "limitedTimeActivityOverTips" : "Hoạt động đã hết hạn, hãy làm mới giao diện",
    "preRightsIntro" : "Do tính năng được làm mới, HĐ \"Điểm VIP\" cũ sẽ sớm bị gỡ xuống.<br/>Thời gian gỡ: \${offLineDate}<br/>Hãy dùng các phiếu ưu đãi từ HĐ \"Điểm VIP\" cũ kịp thời để tránh vượt quá thời hạn sử dụng.<br/>Sau khi HĐ kết thúc, bạn có thể đến Trung Tâm Hội Viên để trải nghiệm thêm nhiều quyền lợi:<br/>Hoàn thành nhiệm vụ để nhận điểm, dùng điểm để đổi thưởng phiếu ưu đãi, đạo cụ! Còn có các quyền lợi thành viên độc quyền, rút thăm trúng thưởng bằng điểm và các hoạt động phúc lợi khác.<br/>Vui lòng chờ đón.",
    "riskTipTitle" : "Cảnh giác với hành vi vi phạm và rủi ro lừa đảo",
    "riskTipContent" : "Các bạn thân mến,\n\nHiện tại, chúng tôi nhận thấy một số người chơi đang thực hiện các hành vi vi phạm, phá hoại trật tự và tính công bằng của trò chơi, thường gặp như:\n\n1. Đăng quảng cáo vi phạm: Sử dụng các kênh như trò chuyện để đăng quảng cáo vi phạm, chẳng hạn như giao dịch tài nguyên bất hợp pháp, nạp tiền bất hợp pháp, v.v.\n2. Sử dụng phần mềm hoặc tập lệnh gian lận Sử dụng phần mềm hoặc tập lệnh gian lận để thu thập tài nguyên hàng loạt một cách bất hợp pháp trong game.\n3. Lời mời vi phạm: Gửi lời mời vi phạm không liên quan đến nội dung game trong khi trò chuyện, dụ dỗ liên hệ qua các kênh bên ngoài game (như Line, Discord).\n4. Nạp tiền bất hợp pháp: Dụ dỗ người chơi nạp tiền qua các kênh không chính thức bằng cách đưa ra ưu đãi giảm giá.\n5. Các hình thức lừa đảo khác: Chẳng hạn như giả mạo nhân viên của NPH, v.v.\n\nChúng tôi muốn nhắc nhở tất cả người chơi hãy bảo vệ tài sản và thông tin cá nhân của mình, đừng tin tưởng bất kỳ thông tin vi phạm và lừa đảo nào. Những hành vi vi phạm nêu trên có rất nhiều rủi ro, không chỉ có nguy cơ làm tài khoản của bạn bị đánh cắp, mà còn có thể liên quan đến hành vi gian lận. Chúng tôi sẽ không hỗ trợ hoặc bồi thường cho bất kỳ tổn thất nào do hành vi vi phạm gây ra.\n\nĐối với các tài khoản vi phạm, chúng tôi sẽ có các biện pháp xử lý tùy theo mức độ nghiêm trọng và phạm vi ảnh hưởng của vi phạm, bao gồm nhưng không giới hạn ở việc cảnh cáo, tịch thu các lợi ích bất hợp pháp, tạm thời hoặc vĩnh viễn khóa tài khoản game. Nếu bạn gặp bất kỳ hành vi đáng ngờ nào trong game, bạn có thể liên hệ với bộ phận CSKH để báo cáo cho chúng tôi. Chúng tôi sẽ xác nhận và xử lý kịp thời. Xin chân thành cảm ơn sự thấu hiểu và ủng hộ của các bạn.",
    "linkValid": "Liên kết này đã hết hạn",
    "-" : "-",
    "accountLabel": "Tài Khoản",
    "passwordLabel": "Mật Khẩu",
    "confirmPasswordLabel": "Xác nhận mật khẩu",
    "confirmDeleteTitle" : "Xác nhận xóa tài khoản game và toàn bộ nhân vật?",
    "confirmDeleteYes" : "Tôi xác nhận xóa tài khoản game và toàn bộ nhân vật.",
    "selectGame" : "Chọn trò chơi",
    "confirmDeleteNo" : "Không, tôi chỉ muốn xóa nhân vật, tài khoản game vẫn giữ.",
    "delTermsTitle" : "Vui lòng đọc kỹ điều kiện và lưu ý xóa tài khoản.",
    "delCondTitle" : "1. Điều kiện xóa tài khoản",
    "delCond1" : "(1) Tài khoản game và nhân vật thuộc về tài khoản này phải do chính bạn đăng ký và sử dụng. <span>Vui lòng đăng nhập tài khoản trước khi gửi yêu cầu xóa. </span>Nếu không thể đăng nhập, hãy [Khôi phục tài khoản] trước.",
    "delCond2" : "(2) Tài khoản game và nhân vật thuộc về tài khoản này <span>không gặp bất kỳ rủi ro bảo mật nào</span>, bao gồm nhưng không giới hạn ở: không có khiếu nại, tố cáo, điều tra, trọng tài, kiện tụng nào đang chờ xử lý, cũng như không bị khiếu nại, tố cáo, điều tra, trọng tài, kiện tụng. \n",
    "delCond3" : "(3) Tài khoản game và nhân vật thuộc về tài khoản này <span>không có bất kỳ khoản thanh toán nào chưa được xử lý</span>, bao gồm nhưng không giới hạn ở khoản hoàn tiền chưa hoàn tất, đăng ký chưa hủy, v.v.",
    "delNoticeTitle" : "2. Lưu ý khi xóa tài khoản",
    "delNotice1" : "(1) Bạn đang yêu cầu xóa tài khoản game và nhân vật thuộc về tài khoản này. Sau khi <span>xóa xong, bạn sẽ không thể đăng nhập hoặc khôi phục tài khoản.</span>",
    "delNotice2" : "(2) Vui lòng <span>xử lý hết tài sản trong game của tài khoản và nhân vật</span>, bao gồm nhưng không giới hạn ở vật phẩm, tiền ảo, gói đăng ký, v.v. Sau khi xóa xong, toàn bộ tài sản trong game sẽ bị xóa. Sau khi game ngừng hoạt động, tài khoản và nhân vật đã bị xóa sẽ không được hoàn tiền.",
    "delNotice3" : "(3) Sau khi xóa tài khoản và thông tin nhân vật, các thông tin liên quan đến tài khoản này cũng sẽ bị xóa hoặc ẩn danh. Tuy nhiên, thông tin đăng nhập bằng mạng xã hội bên thứ ba (như liên kết Facebook) cần được người chơi tự hủy liên kết và xóa thông tin trên nền tảng mạng xã hội tương ứng.",
    "delNotice4" : "(4) Để bảo vệ quyền lợi của bạn, chúng tôi sẽ giữ tài khoản của bạn trong 14 ngày (ngoại trừ một số khu vực theo quy định pháp luật địa phương), tức là thời gian suy nghĩ lại. Trong thời gian này, bạn có thể liên hệ bộ phận hỗ trợ khách hàng để hủy yêu cầu xóa.",
    "delNotice5" : "(5) Sau khi yêu cầu xóa tài khoản được gửi thành công, chúng tôi sẽ ngay lập tức đóng băng tài khoản. Tuy nhiên, việc xóa dữ liệu có thể mất khoảng một tuần để hoàn tất. Vì vậy, chúng tôi sẽ gửi email thông báo cho bạn ngay khi quá trình xóa hoàn tất.",
    "delFormConfirm1" : "Tôi đã đọc kỹ và hiểu rõ các điều kiện và hậu quả của việc xóa tài khoản",
    "delFormConfirm2" : "Tài khoản tôi muốn xóa không dính dáng đến bất kỳ khiếu nại hay vụ kiện nào chưa được giải quyết",
    "delForm" : "Tôi đã đọc và đồng ý với <a class=\"account-delete-link\" href=\"javascript:;\">”Thỏa thuận xóa tài khoản”</a>",
    "cannotDeleteMsgTitle" : "Không thể xóa tài khoản",
    "cannotDeleteMsg1" : "Tài khoản của bạn chưa đáp ứng đủ điều kiện xóa tài khoản sau:",
    "cannotDeleteMsg2" : "Bạn còn đơn khiếu nại chưa được xử lý. Vui lòng quay lại sau khi đơn được hoàn tất.",
    "cannotDeleteMsg3" : "Bạn còn khoản hoàn tiền chưa thanh toán. Vui lòng thanh toán trước khi gửi yêu cầu xóa tài khoản.",
    "cannotDeleteMsg4" : "Tài khoản của bạn đang bị khiếu nại hoặc tố cáo. Vui lòng quay lại sau khi khiếu nại được xử lý.",
    "formCompleted" : "Đã hoàn tất phiếu yêu cầu",
    "formCheckMsg1" : "Phiếu yêu cầu của bạn đã được gửi. Vui lòng chờ phản hồi từ bộ phận hỗ trợ.",
    "formCheckMsg2" : "Bạn có thể xem tiến độ xử lý tại <span class=\"account-delete-link\">[Phiếu yêu cầu của tôi]</span>.",
    "delEmailMsg1" : "Bạn có muốn được thông báo qua email sau khi tài khoản bị xóa?",
    "delEmailMsg2" : "Vì việc xóa tài khoản cần xử lý một lượng dữ liệu lớn, quá trình xóa hoàn toàn sẽ mất khoảng một tuần. Bạn có muốn chúng tôi gửi email thông báo sau khi hoàn tất không?",
    "delEmailMsg3" : "Địa chỉ email bạn cung cấp chỉ được sử dụng cho mục đích thông báo và sẽ không được dùng cho bất kỳ mục đích nào khác.",
    "delEmailConfirmYes" : "Có, vui lòng thông báo cho tôi qua email.",
    "delEmailFill" : "Vui lòng nhập email thông báo.",
    "delEmailConfirmNo" : "Không, tôi không cần thông báo qua email.",
    "delCoolMsg1" : "Áp dụng thời gian suy nghĩ lại 14 ngày?",
    "delCoolMsg2" : "Trong 14 ngày này, tài khoản của bạn sẽ bị đóng băng, nhưng bạn có thể gửi yêu cầu hủy xóa bất cứ lúc nào. Sau 14 ngày, nếu bạn không hủy, tài khoản sẽ bị xóa vĩnh viễn.",
    "delCoolMsg3" : "Nếu bạn không chọn thời gian chờ, tài khoản sẽ bị xóa ngay sau khi bạn gửi yêu cầu và không thể khôi phục.",
    "delCoolConfirmYes" : "Có, tôi muốn chờ 14 ngày.",
    "delCoolConfirmNo" : "Không, tôi muốn xóa ngay.",
    "delSecondCheckMsg1" : "Bạn chắc chắn đã xử lý xong mọi thứ trong tài khoản và muốn áp dụng thời gian suy nghĩ lại ngay bây giờ? Sau khi thực hiện, bạn sẽ không thể đăng nhập vào tài khoản.",
    "delSecondCheckConfirmYes" : "Rồi, bắt đầu ngay.",
    "delResMsg1" : "Yêu cầu xóa tài khoản của bạn đã được gửi. Tài khoản sau đã bị đóng băng và không thể đăng nhập:",
    "gameName" : "Tên nhân vật:",
    "gameAccount" : "Tài khoản:",
    "delResMsg2" : "<span>Vui lòng chụp màn hình và sao chép thông tin tài khoản trên. Nếu bạn muốn khôi phục tài khoản trong thời gian suy nghĩ lại, đây là bằng chứng duy nhất.</span>",
    "delResMsg3" : "Thời gian suy nghĩ lại là 14 ngày, thời gian còn lại:",
    "delResMsg4" : "Nếu bạn muốn hủy yêu cầu xóa trong thời gian suy nghĩ lại, vui lòng nhấn vào [Liên hệ CSKH] trong thời gian này.",
    "copyAccountInfo" : "Sao chép thông tin tài khoản",
    "delResMsg5" : "Bạn đã hoàn tất yêu cầu xóa tài khoản. Tài khoản của bạn hiện đang trong quá trình xóa và không thể đăng nhập.",
    "delResMsg6" : "Vì việc xóa tài khoản cần xử lý một lượng dữ liệu lớn, quá trình này sẽ mất một khoảng thời gian. Dấu vết tài khoản sẽ không bị xóa ngay lập tức, chúng tôi sẽ hoàn tất trong khoảng một tuần.",
    "delResMsg7" : "Nếu bạn đã cung cấp địa chỉ email, chúng tôi sẽ gửi email thông báo đến địa chỉ đó.",
    "delResMsg8" : "Nếu bạn muốn đăng nhập lại trò chơi, vui lòng đăng ký tài khoản mới.",
    "appleOption" : "App Store",
    "googleOption" : "Google Play",
    "otherOption" : "Các kênh khác",
    "itemWrong" : "Thông tin nhập sai, vui lòng nhập lại",
    "delRegisterTime" : "Thời gian đăng ký",
    "delDevice" : "Loại thiết bị thường dùng",
    "delIp" : "IP thường dùng",
    "delHistoryPayChannel" : "Kênh nạp tiền lịch sử",
    "delHistoryPayOrder" : "Mã đơn nạp trong quá khứ",
    "delDeleteReason" : "Lý do xóa tài khoản",
    "delPrevStep" : "Bước trước",
    "delNextStep" : "Bước tiếp",
    "delSecondCheckMsg2" : "Bạn chắc chắn đã xử lý xong mọi thứ trong tài khoản và muốn xóa tài khoản ngay bây giờ? Sau khi thực hiện, bạn sẽ không thể đăng nhập vào tài khoản.",
    "pleaseFillIn" : "Vui lòng điền thông tin dưới đây",
       "switchNewVersion": "Chuyển sang phiên bản mới",
    "switchNewVersionPlatform": "Nền tảng thanh toán",
    "updateVersionPopupContent": "Để đảm bảo hiệu suất trò chơi mượt mà và hỗ trợ các tính năng mới trong tương lai, chúng tôi khuyên bạn nên nâng cấp hệ thống thiết bị của mình để có trải nghiệm vận hành ổn định hơn và tối ưu hóa khả năng tương thích.",
    selectTopupTips:"90% game thủ tin chọn cổng nạp chính thức",
    chuzhi: "Nạp",
    selectMethods: "Phương thức thanh toán",
    landscapeTip2: "Vui lòng xoay điện thoại của bạn sang chế độ dọc để có trải nghiệm tốt hơn",
    v3LaunchFromDesktopAndRewardToMailbox: 'Please launch from the desktop\nSelect a character and the reward will be sent to your mailbox'
}